/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SetPasswordRouteImport } from './routes/set-password'
import { Route as SdkMissingParamsMessageRouteImport } from './routes/sdk-missing-params-message'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as PostLoginRouteImport } from './routes/post-login'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ErrorMessageRouteImport } from './routes/error-message'
import { Route as DashboardUnavailableMessageRouteImport } from './routes/dashboard-unavailable-message'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as AuthenticationErrorMessageRouteImport } from './routes/authentication-error-message'
import { Route as AccountErrorMessageRouteImport } from './routes/account-error-message'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UsersIndexRouteImport } from './routes/users.index'
import { Route as UsersAcceptRouteImport } from './routes/users.accept'
import { Route as SitesSplatRouteImport } from './routes/sites.$'
import { Route as ProfileChangePasswordRouteImport } from './routes/profile.change-password'
import { Route as NSdkMissingParamsMessageRouteImport } from './routes/n.sdk-missing-params-message'
import { Route as NNotFoundRouteImport } from './routes/n.not-found'
import { Route as NErrorMessageRouteImport } from './routes/n.error-message'
import { Route as NDashboardUnavailableMessageRouteImport } from './routes/n.dashboard-unavailable-message'
import { Route as NAuthenticationErrorMessageRouteImport } from './routes/n.authentication-error-message'
import { Route as NAccountSwitchReauthRouteImport } from './routes/n.account-switch-reauth'
import { Route as NAccountErrorMessageRouteImport } from './routes/n.account-error-message'
import { Route as NPublicRouteImport } from './routes/n._public'
import { Route as NAuthRouteImport } from './routes/n._auth'
import { Route as NSplatRouteImport } from './routes/n.$'
import { Route as LoginWpsitecontrolRouteImport } from './routes/login.wpsitecontrol'
import { Route as NPublicRegisterRouteImport } from './routes/n._public.register'
import { Route as NAuthSettingsRouteImport } from './routes/n._auth.settings'
import { Route as NAuthNoAccountsRouteImport } from './routes/n._auth.no-accounts'
import { Route as NAuthFeatureRequestsRouteImport } from './routes/n._auth.feature-requests'
import { Route as NAuthDashboardRouteImport } from './routes/n._auth.dashboard'
import { Route as ManageSiteIdWordpressRouteImport } from './routes/manage.$siteId.wordpress'
import { Route as ManageSiteIdPhpmyadminRouteImport } from './routes/manage.$siteId.phpmyadmin'
import { Route as NAuthSitesIndexRouteImport } from './routes/n._auth.sites.index'
import { Route as NAuthFeatureRequestsIndexRouteImport } from './routes/n._auth.feature-requests.index'
import { Route as NAuthSitesSiteIdRouteImport } from './routes/n._auth.sites.$siteId'
import { Route as NAuthSettingsLayoutRouteImport } from './routes/n._auth.settings._layout'
import { Route as NAuthRegisterSuccessRouteImport } from './routes/n._auth.register.success'
import { Route as NAuthRegisterPlanRouteImport } from './routes/n._auth.register.plan'
import { Route as NAuthFeatureRequestsSplatRouteImport } from './routes/n._auth.feature-requests.$'
import { Route as NAuthSettingsLayoutIndexRouteImport } from './routes/n._auth.settings._layout.index'
import { Route as NAuthSitesSiteIdInviteAcceptRouteImport } from './routes/n._auth.sites.$siteId.invite-accept'
import { Route as NAuthSitesSiteIdDetailsRouteImport } from './routes/n._auth.sites.$siteId._details'
import { Route as NAuthManageSiteIdWordpressRouteImport } from './routes/n._auth.manage.$siteId.wordpress'
import { Route as NAuthManageSiteIdPhpmyadminRouteImport } from './routes/n._auth.manage.$siteId.phpmyadmin'
import { Route as NAuthSitesSiteIdDetailsIndexRouteImport } from './routes/n._auth.sites.$siteId._details.index'
import { Route as NAuthSettingsLayoutUsersIndexRouteImport } from './routes/n._auth.settings._layout.users.index'
import { Route as NAuthSettingsLayoutTemplatesIndexRouteImport } from './routes/n._auth.settings._layout.templates.index'
import { Route as NAuthSettingsLayoutEmailHistoryIndexRouteImport } from './routes/n._auth.settings._layout.email-history.index'
import { Route as NAuthSettingsLayoutBillingIndexRouteImport } from './routes/n._auth.settings._layout.billing.index'
import { Route as NAuthSettingsLayoutAccountAndSecurityIndexRouteImport } from './routes/n._auth.settings._layout.account-and-security.index'
import { Route as NAuthSitesSiteIdDetailsThemesRouteImport } from './routes/n._auth.sites.$siteId._details.themes'
import { Route as NAuthSitesSiteIdDetailsSecurityRouteImport } from './routes/n._auth.sites.$siteId._details.security'
import { Route as NAuthSitesSiteIdDetailsReportingRouteImport } from './routes/n._auth.sites.$siteId._details.reporting'
import { Route as NAuthSitesSiteIdDetailsPluginsRouteImport } from './routes/n._auth.sites.$siteId._details.plugins'
import { Route as NAuthSitesSiteIdDetailsOverviewRouteImport } from './routes/n._auth.sites.$siteId._details.overview'
import { Route as NAuthSitesSiteIdDetailsLogsRouteImport } from './routes/n._auth.sites.$siteId._details.logs'
import { Route as NAuthSitesSiteIdDetailsFileManagerRouteImport } from './routes/n._auth.sites.$siteId._details.file-manager'
import { Route as NAuthSitesSiteIdDetailsBackupsRouteImport } from './routes/n._auth.sites.$siteId._details.backups'
import { Route as NAuthSitesSiteIdDetailsAdvancedRouteImport } from './routes/n._auth.sites.$siteId._details.advanced'
import { Route as NAuthSettingsLayoutTemplatesTemplateIdRouteImport } from './routes/n._auth.settings._layout.templates.$templateId'
import { Route as NAuthSettingsLayoutEmailHistoryEmailIdRouteImport } from './routes/n._auth.settings._layout.email-history.$emailId'
import { Route as NAuthSettingsLayoutBillingAddPaymentMethodRouteImport } from './routes/n._auth.settings._layout.billing.add-payment-method'
import { Route as NAuthSettingsLayoutAccountAndSecurityChangePasswordRouteImport } from './routes/n._auth.settings._layout.account-and-security.change-password'
import { Route as NAuthSitesSiteIdDetailsThemesIndexRouteImport } from './routes/n._auth.sites.$siteId._details.themes.index'
import { Route as NAuthSitesSiteIdDetailsReportingIndexRouteImport } from './routes/n._auth.sites.$siteId._details.reporting.index'
import { Route as NAuthSitesSiteIdDetailsPluginsIndexRouteImport } from './routes/n._auth.sites.$siteId._details.plugins.index'
import { Route as NAuthSitesSiteIdDetailsLogsIndexRouteImport } from './routes/n._auth.sites.$siteId._details.logs.index'
import { Route as NAuthSitesSiteIdDetailsThemesDiscoverRouteImport } from './routes/n._auth.sites.$siteId._details.themes.discover'
import { Route as NAuthSitesSiteIdDetailsReportingWafRouteImport } from './routes/n._auth.sites.$siteId._details.reporting.waf'
import { Route as NAuthSitesSiteIdDetailsReportingDeliveryRouteImport } from './routes/n._auth.sites.$siteId._details.reporting.delivery'
import { Route as NAuthSitesSiteIdDetailsPluginsDiscoverRouteImport } from './routes/n._auth.sites.$siteId._details.plugins.discover'
import { Route as NAuthSitesSiteIdDetailsLogsWafLogRouteImport } from './routes/n._auth.sites.$siteId._details.logs.waf-log'
import { Route as NAuthSitesSiteIdDetailsLogsAccessLogRouteImport } from './routes/n._auth.sites.$siteId._details.logs.access-log'
import { Route as NAuthSettingsLayoutUsersUserIdSiteRouteImport } from './routes/n._auth.settings._layout.users.$userId.site'
import { Route as NAuthSettingsLayoutUsersUserIdAccountRouteImport } from './routes/n._auth.settings._layout.users.$userId.account'
import { Route as NAuthSettingsLayoutBillingInvoiceInvoiceIdRouteImport } from './routes/n._auth.settings._layout.billing.invoice.$invoiceId'
import { Route as NAuthSettingsLayoutBillingEditPlanTabsRouteImport } from './routes/n._auth.settings._layout.billing.edit-plan._tabs'
import { Route as NAuthSettingsLayoutBillingEditPlanTabsIndexRouteImport } from './routes/n._auth.settings._layout.billing.edit-plan._tabs.index'
import { Route as NAuthSettingsLayoutBillingEditPlanOrderConfirmationOrderIdRouteImport } from './routes/n._auth.settings._layout.billing.edit-plan.order-confirmation.$orderId'
import { Route as NAuthSettingsLayoutBillingEditPlanTabsPlanTypeRouteImport } from './routes/n._auth.settings._layout.billing.edit-plan._tabs.$planType'
import { Route as NAuthSettingsLayoutBillingEditPlanConfirmPlanIdCycleBillingCycleRouteImport } from './routes/n._auth.settings._layout.billing.edit-plan.confirm.$planId.cycle.$billingCycle'

const SetPasswordRoute = SetPasswordRouteImport.update({
  id: '/set-password',
  path: '/set-password',
  getParentRoute: () => rootRouteImport,
} as any)
const SdkMissingParamsMessageRoute = SdkMissingParamsMessageRouteImport.update({
  id: '/sdk-missing-params-message',
  path: '/sdk-missing-params-message',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const PostLoginRoute = PostLoginRouteImport.update({
  id: '/post-login',
  path: '/post-login',
  getParentRoute: () => rootRouteImport,
} as any)
const LogoutRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ErrorMessageRoute = ErrorMessageRouteImport.update({
  id: '/error-message',
  path: '/error-message',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardUnavailableMessageRoute =
  DashboardUnavailableMessageRouteImport.update({
    id: '/dashboard-unavailable-message',
    path: '/dashboard-unavailable-message',
    getParentRoute: () => rootRouteImport,
  } as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticationErrorMessageRoute =
  AuthenticationErrorMessageRouteImport.update({
    id: '/authentication-error-message',
    path: '/authentication-error-message',
    getParentRoute: () => rootRouteImport,
  } as any)
const AccountErrorMessageRoute = AccountErrorMessageRouteImport.update({
  id: '/account-error-message',
  path: '/account-error-message',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersIndexRoute = UsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersAcceptRoute = UsersAcceptRouteImport.update({
  id: '/users/accept',
  path: '/users/accept',
  getParentRoute: () => rootRouteImport,
} as any)
const SitesSplatRoute = SitesSplatRouteImport.update({
  id: '/sites/$',
  path: '/sites/$',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileChangePasswordRoute = ProfileChangePasswordRouteImport.update({
  id: '/profile/change-password',
  path: '/profile/change-password',
  getParentRoute: () => rootRouteImport,
} as any)
const NSdkMissingParamsMessageRoute =
  NSdkMissingParamsMessageRouteImport.update({
    id: '/n/sdk-missing-params-message',
    path: '/n/sdk-missing-params-message',
    getParentRoute: () => rootRouteImport,
  } as any)
const NNotFoundRoute = NNotFoundRouteImport.update({
  id: '/n/not-found',
  path: '/n/not-found',
  getParentRoute: () => rootRouteImport,
} as any)
const NErrorMessageRoute = NErrorMessageRouteImport.update({
  id: '/n/error-message',
  path: '/n/error-message',
  getParentRoute: () => rootRouteImport,
} as any)
const NDashboardUnavailableMessageRoute =
  NDashboardUnavailableMessageRouteImport.update({
    id: '/n/dashboard-unavailable-message',
    path: '/n/dashboard-unavailable-message',
    getParentRoute: () => rootRouteImport,
  } as any)
const NAuthenticationErrorMessageRoute =
  NAuthenticationErrorMessageRouteImport.update({
    id: '/n/authentication-error-message',
    path: '/n/authentication-error-message',
    getParentRoute: () => rootRouteImport,
  } as any)
const NAccountSwitchReauthRoute = NAccountSwitchReauthRouteImport.update({
  id: '/n/account-switch-reauth',
  path: '/n/account-switch-reauth',
  getParentRoute: () => rootRouteImport,
} as any)
const NAccountErrorMessageRoute = NAccountErrorMessageRouteImport.update({
  id: '/n/account-error-message',
  path: '/n/account-error-message',
  getParentRoute: () => rootRouteImport,
} as any)
const NPublicRoute = NPublicRouteImport.update({
  id: '/n/_public',
  path: '/n',
  getParentRoute: () => rootRouteImport,
} as any)
const NAuthRoute = NAuthRouteImport.update({
  id: '/n/_auth',
  path: '/n',
  getParentRoute: () => rootRouteImport,
} as any)
const NSplatRoute = NSplatRouteImport.update({
  id: '/n/$',
  path: '/n/$',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginWpsitecontrolRoute = LoginWpsitecontrolRouteImport.update({
  id: '/wpsitecontrol',
  path: '/wpsitecontrol',
  getParentRoute: () => LoginRoute,
} as any)
const NPublicRegisterRoute = NPublicRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => NPublicRoute,
} as any)
const NAuthSettingsRoute = NAuthSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => NAuthRoute,
} as any)
const NAuthNoAccountsRoute = NAuthNoAccountsRouteImport.update({
  id: '/no-accounts',
  path: '/no-accounts',
  getParentRoute: () => NAuthRoute,
} as any)
const NAuthFeatureRequestsRoute = NAuthFeatureRequestsRouteImport.update({
  id: '/feature-requests',
  path: '/feature-requests',
  getParentRoute: () => NAuthRoute,
} as any)
const NAuthDashboardRoute = NAuthDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => NAuthRoute,
} as any)
const ManageSiteIdWordpressRoute = ManageSiteIdWordpressRouteImport.update({
  id: '/manage/$siteId/wordpress',
  path: '/manage/$siteId/wordpress',
  getParentRoute: () => rootRouteImport,
} as any)
const ManageSiteIdPhpmyadminRoute = ManageSiteIdPhpmyadminRouteImport.update({
  id: '/manage/$siteId/phpmyadmin',
  path: '/manage/$siteId/phpmyadmin',
  getParentRoute: () => rootRouteImport,
} as any)
const NAuthSitesIndexRoute = NAuthSitesIndexRouteImport.update({
  id: '/sites/',
  path: '/sites/',
  getParentRoute: () => NAuthRoute,
} as any)
const NAuthFeatureRequestsIndexRoute =
  NAuthFeatureRequestsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => NAuthFeatureRequestsRoute,
  } as any)
const NAuthSitesSiteIdRoute = NAuthSitesSiteIdRouteImport.update({
  id: '/sites/$siteId',
  path: '/sites/$siteId',
  getParentRoute: () => NAuthRoute,
} as any)
const NAuthSettingsLayoutRoute = NAuthSettingsLayoutRouteImport.update({
  id: '/_layout',
  getParentRoute: () => NAuthSettingsRoute,
} as any)
const NAuthRegisterSuccessRoute = NAuthRegisterSuccessRouteImport.update({
  id: '/register/success',
  path: '/register/success',
  getParentRoute: () => NAuthRoute,
} as any)
const NAuthRegisterPlanRoute = NAuthRegisterPlanRouteImport.update({
  id: '/register/plan',
  path: '/register/plan',
  getParentRoute: () => NAuthRoute,
} as any)
const NAuthFeatureRequestsSplatRoute =
  NAuthFeatureRequestsSplatRouteImport.update({
    id: '/$',
    path: '/$',
    getParentRoute: () => NAuthFeatureRequestsRoute,
  } as any)
const NAuthSettingsLayoutIndexRoute =
  NAuthSettingsLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => NAuthSettingsLayoutRoute,
  } as any)
const NAuthSitesSiteIdInviteAcceptRoute =
  NAuthSitesSiteIdInviteAcceptRouteImport.update({
    id: '/invite-accept',
    path: '/invite-accept',
    getParentRoute: () => NAuthSitesSiteIdRoute,
  } as any)
const NAuthSitesSiteIdDetailsRoute = NAuthSitesSiteIdDetailsRouteImport.update({
  id: '/_details',
  getParentRoute: () => NAuthSitesSiteIdRoute,
} as any)
const NAuthManageSiteIdWordpressRoute =
  NAuthManageSiteIdWordpressRouteImport.update({
    id: '/manage/$siteId/wordpress',
    path: '/manage/$siteId/wordpress',
    getParentRoute: () => NAuthRoute,
  } as any)
const NAuthManageSiteIdPhpmyadminRoute =
  NAuthManageSiteIdPhpmyadminRouteImport.update({
    id: '/manage/$siteId/phpmyadmin',
    path: '/manage/$siteId/phpmyadmin',
    getParentRoute: () => NAuthRoute,
  } as any)
const NAuthSitesSiteIdDetailsIndexRoute =
  NAuthSitesSiteIdDetailsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => NAuthSitesSiteIdDetailsRoute,
  } as any)
const NAuthSettingsLayoutUsersIndexRoute =
  NAuthSettingsLayoutUsersIndexRouteImport.update({
    id: '/users/',
    path: '/users/',
    getParentRoute: () => NAuthSettingsLayoutRoute,
  } as any)
const NAuthSettingsLayoutTemplatesIndexRoute =
  NAuthSettingsLayoutTemplatesIndexRouteImport.update({
    id: '/templates/',
    path: '/templates/',
    getParentRoute: () => NAuthSettingsLayoutRoute,
  } as any)
const NAuthSettingsLayoutEmailHistoryIndexRoute =
  NAuthSettingsLayoutEmailHistoryIndexRouteImport.update({
    id: '/email-history/',
    path: '/email-history/',
    getParentRoute: () => NAuthSettingsLayoutRoute,
  } as any)
const NAuthSettingsLayoutBillingIndexRoute =
  NAuthSettingsLayoutBillingIndexRouteImport.update({
    id: '/billing/',
    path: '/billing/',
    getParentRoute: () => NAuthSettingsLayoutRoute,
  } as any)
const NAuthSettingsLayoutAccountAndSecurityIndexRoute =
  NAuthSettingsLayoutAccountAndSecurityIndexRouteImport.update({
    id: '/account-and-security/',
    path: '/account-and-security/',
    getParentRoute: () => NAuthSettingsLayoutRoute,
  } as any)
const NAuthSitesSiteIdDetailsThemesRoute =
  NAuthSitesSiteIdDetailsThemesRouteImport.update({
    id: '/themes',
    path: '/themes',
    getParentRoute: () => NAuthSitesSiteIdDetailsRoute,
  } as any)
const NAuthSitesSiteIdDetailsSecurityRoute =
  NAuthSitesSiteIdDetailsSecurityRouteImport.update({
    id: '/security',
    path: '/security',
    getParentRoute: () => NAuthSitesSiteIdDetailsRoute,
  } as any)
const NAuthSitesSiteIdDetailsReportingRoute =
  NAuthSitesSiteIdDetailsReportingRouteImport.update({
    id: '/reporting',
    path: '/reporting',
    getParentRoute: () => NAuthSitesSiteIdDetailsRoute,
  } as any)
const NAuthSitesSiteIdDetailsPluginsRoute =
  NAuthSitesSiteIdDetailsPluginsRouteImport.update({
    id: '/plugins',
    path: '/plugins',
    getParentRoute: () => NAuthSitesSiteIdDetailsRoute,
  } as any)
const NAuthSitesSiteIdDetailsOverviewRoute =
  NAuthSitesSiteIdDetailsOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => NAuthSitesSiteIdDetailsRoute,
  } as any)
const NAuthSitesSiteIdDetailsLogsRoute =
  NAuthSitesSiteIdDetailsLogsRouteImport.update({
    id: '/logs',
    path: '/logs',
    getParentRoute: () => NAuthSitesSiteIdDetailsRoute,
  } as any)
const NAuthSitesSiteIdDetailsFileManagerRoute =
  NAuthSitesSiteIdDetailsFileManagerRouteImport.update({
    id: '/file-manager',
    path: '/file-manager',
    getParentRoute: () => NAuthSitesSiteIdDetailsRoute,
  } as any)
const NAuthSitesSiteIdDetailsBackupsRoute =
  NAuthSitesSiteIdDetailsBackupsRouteImport.update({
    id: '/backups',
    path: '/backups',
    getParentRoute: () => NAuthSitesSiteIdDetailsRoute,
  } as any)
const NAuthSitesSiteIdDetailsAdvancedRoute =
  NAuthSitesSiteIdDetailsAdvancedRouteImport.update({
    id: '/advanced',
    path: '/advanced',
    getParentRoute: () => NAuthSitesSiteIdDetailsRoute,
  } as any)
const NAuthSettingsLayoutTemplatesTemplateIdRoute =
  NAuthSettingsLayoutTemplatesTemplateIdRouteImport.update({
    id: '/templates/$templateId',
    path: '/templates/$templateId',
    getParentRoute: () => NAuthSettingsLayoutRoute,
  } as any)
const NAuthSettingsLayoutEmailHistoryEmailIdRoute =
  NAuthSettingsLayoutEmailHistoryEmailIdRouteImport.update({
    id: '/email-history/$emailId',
    path: '/email-history/$emailId',
    getParentRoute: () => NAuthSettingsLayoutRoute,
  } as any)
const NAuthSettingsLayoutBillingAddPaymentMethodRoute =
  NAuthSettingsLayoutBillingAddPaymentMethodRouteImport.update({
    id: '/billing/add-payment-method',
    path: '/billing/add-payment-method',
    getParentRoute: () => NAuthSettingsLayoutRoute,
  } as any)
const NAuthSettingsLayoutAccountAndSecurityChangePasswordRoute =
  NAuthSettingsLayoutAccountAndSecurityChangePasswordRouteImport.update({
    id: '/account-and-security/change-password',
    path: '/account-and-security/change-password',
    getParentRoute: () => NAuthSettingsLayoutRoute,
  } as any)
const NAuthSitesSiteIdDetailsThemesIndexRoute =
  NAuthSitesSiteIdDetailsThemesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => NAuthSitesSiteIdDetailsThemesRoute,
  } as any)
const NAuthSitesSiteIdDetailsReportingIndexRoute =
  NAuthSitesSiteIdDetailsReportingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => NAuthSitesSiteIdDetailsReportingRoute,
  } as any)
const NAuthSitesSiteIdDetailsPluginsIndexRoute =
  NAuthSitesSiteIdDetailsPluginsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => NAuthSitesSiteIdDetailsPluginsRoute,
  } as any)
const NAuthSitesSiteIdDetailsLogsIndexRoute =
  NAuthSitesSiteIdDetailsLogsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => NAuthSitesSiteIdDetailsLogsRoute,
  } as any)
const NAuthSitesSiteIdDetailsThemesDiscoverRoute =
  NAuthSitesSiteIdDetailsThemesDiscoverRouteImport.update({
    id: '/discover',
    path: '/discover',
    getParentRoute: () => NAuthSitesSiteIdDetailsThemesRoute,
  } as any)
const NAuthSitesSiteIdDetailsReportingWafRoute =
  NAuthSitesSiteIdDetailsReportingWafRouteImport.update({
    id: '/waf',
    path: '/waf',
    getParentRoute: () => NAuthSitesSiteIdDetailsReportingRoute,
  } as any)
const NAuthSitesSiteIdDetailsReportingDeliveryRoute =
  NAuthSitesSiteIdDetailsReportingDeliveryRouteImport.update({
    id: '/delivery',
    path: '/delivery',
    getParentRoute: () => NAuthSitesSiteIdDetailsReportingRoute,
  } as any)
const NAuthSitesSiteIdDetailsPluginsDiscoverRoute =
  NAuthSitesSiteIdDetailsPluginsDiscoverRouteImport.update({
    id: '/discover',
    path: '/discover',
    getParentRoute: () => NAuthSitesSiteIdDetailsPluginsRoute,
  } as any)
const NAuthSitesSiteIdDetailsLogsWafLogRoute =
  NAuthSitesSiteIdDetailsLogsWafLogRouteImport.update({
    id: '/waf-log',
    path: '/waf-log',
    getParentRoute: () => NAuthSitesSiteIdDetailsLogsRoute,
  } as any)
const NAuthSitesSiteIdDetailsLogsAccessLogRoute =
  NAuthSitesSiteIdDetailsLogsAccessLogRouteImport.update({
    id: '/access-log',
    path: '/access-log',
    getParentRoute: () => NAuthSitesSiteIdDetailsLogsRoute,
  } as any)
const NAuthSettingsLayoutUsersUserIdSiteRoute =
  NAuthSettingsLayoutUsersUserIdSiteRouteImport.update({
    id: '/users/$userId/site',
    path: '/users/$userId/site',
    getParentRoute: () => NAuthSettingsLayoutRoute,
  } as any)
const NAuthSettingsLayoutUsersUserIdAccountRoute =
  NAuthSettingsLayoutUsersUserIdAccountRouteImport.update({
    id: '/users/$userId/account',
    path: '/users/$userId/account',
    getParentRoute: () => NAuthSettingsLayoutRoute,
  } as any)
const NAuthSettingsLayoutBillingInvoiceInvoiceIdRoute =
  NAuthSettingsLayoutBillingInvoiceInvoiceIdRouteImport.update({
    id: '/billing/invoice/$invoiceId',
    path: '/billing/invoice/$invoiceId',
    getParentRoute: () => NAuthSettingsLayoutRoute,
  } as any)
const NAuthSettingsLayoutBillingEditPlanTabsRoute =
  NAuthSettingsLayoutBillingEditPlanTabsRouteImport.update({
    id: '/billing/edit-plan/_tabs',
    path: '/billing/edit-plan',
    getParentRoute: () => NAuthSettingsLayoutRoute,
  } as any)
const NAuthSettingsLayoutBillingEditPlanTabsIndexRoute =
  NAuthSettingsLayoutBillingEditPlanTabsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => NAuthSettingsLayoutBillingEditPlanTabsRoute,
  } as any)
const NAuthSettingsLayoutBillingEditPlanOrderConfirmationOrderIdRoute =
  NAuthSettingsLayoutBillingEditPlanOrderConfirmationOrderIdRouteImport.update({
    id: '/billing/edit-plan/order-confirmation/$orderId',
    path: '/billing/edit-plan/order-confirmation/$orderId',
    getParentRoute: () => NAuthSettingsLayoutRoute,
  } as any)
const NAuthSettingsLayoutBillingEditPlanTabsPlanTypeRoute =
  NAuthSettingsLayoutBillingEditPlanTabsPlanTypeRouteImport.update({
    id: '/$planType',
    path: '/$planType',
    getParentRoute: () => NAuthSettingsLayoutBillingEditPlanTabsRoute,
  } as any)
const NAuthSettingsLayoutBillingEditPlanConfirmPlanIdCycleBillingCycleRoute =
  NAuthSettingsLayoutBillingEditPlanConfirmPlanIdCycleBillingCycleRouteImport.update(
    {
      id: '/billing/edit-plan/confirm/$planId/cycle/$billingCycle',
      path: '/billing/edit-plan/confirm/$planId/cycle/$billingCycle',
      getParentRoute: () => NAuthSettingsLayoutRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/account-error-message': typeof AccountErrorMessageRoute
  '/authentication-error-message': typeof AuthenticationErrorMessageRoute
  '/dashboard': typeof DashboardRoute
  '/dashboard-unavailable-message': typeof DashboardUnavailableMessageRoute
  '/error-message': typeof ErrorMessageRoute
  '/login': typeof LoginRouteWithChildren
  '/logout': typeof LogoutRoute
  '/post-login': typeof PostLoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sdk-missing-params-message': typeof SdkMissingParamsMessageRoute
  '/set-password': typeof SetPasswordRoute
  '/login/wpsitecontrol': typeof LoginWpsitecontrolRoute
  '/n/$': typeof NSplatRoute
  '/n': typeof NPublicRouteWithChildren
  '/n/account-error-message': typeof NAccountErrorMessageRoute
  '/n/account-switch-reauth': typeof NAccountSwitchReauthRoute
  '/n/authentication-error-message': typeof NAuthenticationErrorMessageRoute
  '/n/dashboard-unavailable-message': typeof NDashboardUnavailableMessageRoute
  '/n/error-message': typeof NErrorMessageRoute
  '/n/not-found': typeof NNotFoundRoute
  '/n/sdk-missing-params-message': typeof NSdkMissingParamsMessageRoute
  '/profile/change-password': typeof ProfileChangePasswordRoute
  '/sites/$': typeof SitesSplatRoute
  '/users/accept': typeof UsersAcceptRoute
  '/users/': typeof UsersIndexRoute
  '/manage/$siteId/phpmyadmin': typeof ManageSiteIdPhpmyadminRoute
  '/manage/$siteId/wordpress': typeof ManageSiteIdWordpressRoute
  '/n/dashboard': typeof NAuthDashboardRoute
  '/n/feature-requests': typeof NAuthFeatureRequestsRouteWithChildren
  '/n/no-accounts': typeof NAuthNoAccountsRoute
  '/n/settings': typeof NAuthSettingsRouteWithChildren
  '/n/register': typeof NPublicRegisterRoute
  '/n/feature-requests/$': typeof NAuthFeatureRequestsSplatRoute
  '/n/register/plan': typeof NAuthRegisterPlanRoute
  '/n/register/success': typeof NAuthRegisterSuccessRoute
  '/n/sites/$siteId': typeof NAuthSitesSiteIdRouteWithChildren
  '/n/feature-requests/': typeof NAuthFeatureRequestsIndexRoute
  '/n/sites/': typeof NAuthSitesIndexRoute
  '/n/manage/$siteId/phpmyadmin': typeof NAuthManageSiteIdPhpmyadminRoute
  '/n/manage/$siteId/wordpress': typeof NAuthManageSiteIdWordpressRoute
  '/n/sites/$siteId/invite-accept': typeof NAuthSitesSiteIdInviteAcceptRoute
  '/n/settings/': typeof NAuthSettingsLayoutIndexRoute
  '/n/settings/account-and-security/change-password': typeof NAuthSettingsLayoutAccountAndSecurityChangePasswordRoute
  '/n/settings/billing/add-payment-method': typeof NAuthSettingsLayoutBillingAddPaymentMethodRoute
  '/n/settings/email-history/$emailId': typeof NAuthSettingsLayoutEmailHistoryEmailIdRoute
  '/n/settings/templates/$templateId': typeof NAuthSettingsLayoutTemplatesTemplateIdRoute
  '/n/sites/$siteId/advanced': typeof NAuthSitesSiteIdDetailsAdvancedRoute
  '/n/sites/$siteId/backups': typeof NAuthSitesSiteIdDetailsBackupsRoute
  '/n/sites/$siteId/file-manager': typeof NAuthSitesSiteIdDetailsFileManagerRoute
  '/n/sites/$siteId/logs': typeof NAuthSitesSiteIdDetailsLogsRouteWithChildren
  '/n/sites/$siteId/overview': typeof NAuthSitesSiteIdDetailsOverviewRoute
  '/n/sites/$siteId/plugins': typeof NAuthSitesSiteIdDetailsPluginsRouteWithChildren
  '/n/sites/$siteId/reporting': typeof NAuthSitesSiteIdDetailsReportingRouteWithChildren
  '/n/sites/$siteId/security': typeof NAuthSitesSiteIdDetailsSecurityRoute
  '/n/sites/$siteId/themes': typeof NAuthSitesSiteIdDetailsThemesRouteWithChildren
  '/n/settings/account-and-security/': typeof NAuthSettingsLayoutAccountAndSecurityIndexRoute
  '/n/settings/billing/': typeof NAuthSettingsLayoutBillingIndexRoute
  '/n/settings/email-history/': typeof NAuthSettingsLayoutEmailHistoryIndexRoute
  '/n/settings/templates/': typeof NAuthSettingsLayoutTemplatesIndexRoute
  '/n/settings/users/': typeof NAuthSettingsLayoutUsersIndexRoute
  '/n/sites/$siteId/': typeof NAuthSitesSiteIdDetailsIndexRoute
  '/n/settings/billing/edit-plan': typeof NAuthSettingsLayoutBillingEditPlanTabsRouteWithChildren
  '/n/settings/billing/invoice/$invoiceId': typeof NAuthSettingsLayoutBillingInvoiceInvoiceIdRoute
  '/n/settings/users/$userId/account': typeof NAuthSettingsLayoutUsersUserIdAccountRoute
  '/n/settings/users/$userId/site': typeof NAuthSettingsLayoutUsersUserIdSiteRoute
  '/n/sites/$siteId/logs/access-log': typeof NAuthSitesSiteIdDetailsLogsAccessLogRoute
  '/n/sites/$siteId/logs/waf-log': typeof NAuthSitesSiteIdDetailsLogsWafLogRoute
  '/n/sites/$siteId/plugins/discover': typeof NAuthSitesSiteIdDetailsPluginsDiscoverRoute
  '/n/sites/$siteId/reporting/delivery': typeof NAuthSitesSiteIdDetailsReportingDeliveryRoute
  '/n/sites/$siteId/reporting/waf': typeof NAuthSitesSiteIdDetailsReportingWafRoute
  '/n/sites/$siteId/themes/discover': typeof NAuthSitesSiteIdDetailsThemesDiscoverRoute
  '/n/sites/$siteId/logs/': typeof NAuthSitesSiteIdDetailsLogsIndexRoute
  '/n/sites/$siteId/plugins/': typeof NAuthSitesSiteIdDetailsPluginsIndexRoute
  '/n/sites/$siteId/reporting/': typeof NAuthSitesSiteIdDetailsReportingIndexRoute
  '/n/sites/$siteId/themes/': typeof NAuthSitesSiteIdDetailsThemesIndexRoute
  '/n/settings/billing/edit-plan/$planType': typeof NAuthSettingsLayoutBillingEditPlanTabsPlanTypeRoute
  '/n/settings/billing/edit-plan/order-confirmation/$orderId': typeof NAuthSettingsLayoutBillingEditPlanOrderConfirmationOrderIdRoute
  '/n/settings/billing/edit-plan/': typeof NAuthSettingsLayoutBillingEditPlanTabsIndexRoute
  '/n/settings/billing/edit-plan/confirm/$planId/cycle/$billingCycle': typeof NAuthSettingsLayoutBillingEditPlanConfirmPlanIdCycleBillingCycleRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/account-error-message': typeof AccountErrorMessageRoute
  '/authentication-error-message': typeof AuthenticationErrorMessageRoute
  '/dashboard': typeof DashboardRoute
  '/dashboard-unavailable-message': typeof DashboardUnavailableMessageRoute
  '/error-message': typeof ErrorMessageRoute
  '/login': typeof LoginRouteWithChildren
  '/logout': typeof LogoutRoute
  '/post-login': typeof PostLoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sdk-missing-params-message': typeof SdkMissingParamsMessageRoute
  '/set-password': typeof SetPasswordRoute
  '/login/wpsitecontrol': typeof LoginWpsitecontrolRoute
  '/n/$': typeof NSplatRoute
  '/n': typeof NPublicRouteWithChildren
  '/n/account-error-message': typeof NAccountErrorMessageRoute
  '/n/account-switch-reauth': typeof NAccountSwitchReauthRoute
  '/n/authentication-error-message': typeof NAuthenticationErrorMessageRoute
  '/n/dashboard-unavailable-message': typeof NDashboardUnavailableMessageRoute
  '/n/error-message': typeof NErrorMessageRoute
  '/n/not-found': typeof NNotFoundRoute
  '/n/sdk-missing-params-message': typeof NSdkMissingParamsMessageRoute
  '/profile/change-password': typeof ProfileChangePasswordRoute
  '/sites/$': typeof SitesSplatRoute
  '/users/accept': typeof UsersAcceptRoute
  '/users': typeof UsersIndexRoute
  '/manage/$siteId/phpmyadmin': typeof ManageSiteIdPhpmyadminRoute
  '/manage/$siteId/wordpress': typeof ManageSiteIdWordpressRoute
  '/n/dashboard': typeof NAuthDashboardRoute
  '/n/no-accounts': typeof NAuthNoAccountsRoute
  '/n/settings': typeof NAuthSettingsLayoutIndexRoute
  '/n/register': typeof NPublicRegisterRoute
  '/n/feature-requests/$': typeof NAuthFeatureRequestsSplatRoute
  '/n/register/plan': typeof NAuthRegisterPlanRoute
  '/n/register/success': typeof NAuthRegisterSuccessRoute
  '/n/sites/$siteId': typeof NAuthSitesSiteIdDetailsIndexRoute
  '/n/feature-requests': typeof NAuthFeatureRequestsIndexRoute
  '/n/sites': typeof NAuthSitesIndexRoute
  '/n/manage/$siteId/phpmyadmin': typeof NAuthManageSiteIdPhpmyadminRoute
  '/n/manage/$siteId/wordpress': typeof NAuthManageSiteIdWordpressRoute
  '/n/sites/$siteId/invite-accept': typeof NAuthSitesSiteIdInviteAcceptRoute
  '/n/settings/account-and-security/change-password': typeof NAuthSettingsLayoutAccountAndSecurityChangePasswordRoute
  '/n/settings/billing/add-payment-method': typeof NAuthSettingsLayoutBillingAddPaymentMethodRoute
  '/n/settings/email-history/$emailId': typeof NAuthSettingsLayoutEmailHistoryEmailIdRoute
  '/n/settings/templates/$templateId': typeof NAuthSettingsLayoutTemplatesTemplateIdRoute
  '/n/sites/$siteId/advanced': typeof NAuthSitesSiteIdDetailsAdvancedRoute
  '/n/sites/$siteId/backups': typeof NAuthSitesSiteIdDetailsBackupsRoute
  '/n/sites/$siteId/file-manager': typeof NAuthSitesSiteIdDetailsFileManagerRoute
  '/n/sites/$siteId/overview': typeof NAuthSitesSiteIdDetailsOverviewRoute
  '/n/sites/$siteId/security': typeof NAuthSitesSiteIdDetailsSecurityRoute
  '/n/settings/account-and-security': typeof NAuthSettingsLayoutAccountAndSecurityIndexRoute
  '/n/settings/billing': typeof NAuthSettingsLayoutBillingIndexRoute
  '/n/settings/email-history': typeof NAuthSettingsLayoutEmailHistoryIndexRoute
  '/n/settings/templates': typeof NAuthSettingsLayoutTemplatesIndexRoute
  '/n/settings/users': typeof NAuthSettingsLayoutUsersIndexRoute
  '/n/settings/billing/invoice/$invoiceId': typeof NAuthSettingsLayoutBillingInvoiceInvoiceIdRoute
  '/n/settings/users/$userId/account': typeof NAuthSettingsLayoutUsersUserIdAccountRoute
  '/n/settings/users/$userId/site': typeof NAuthSettingsLayoutUsersUserIdSiteRoute
  '/n/sites/$siteId/logs/access-log': typeof NAuthSitesSiteIdDetailsLogsAccessLogRoute
  '/n/sites/$siteId/logs/waf-log': typeof NAuthSitesSiteIdDetailsLogsWafLogRoute
  '/n/sites/$siteId/plugins/discover': typeof NAuthSitesSiteIdDetailsPluginsDiscoverRoute
  '/n/sites/$siteId/reporting/delivery': typeof NAuthSitesSiteIdDetailsReportingDeliveryRoute
  '/n/sites/$siteId/reporting/waf': typeof NAuthSitesSiteIdDetailsReportingWafRoute
  '/n/sites/$siteId/themes/discover': typeof NAuthSitesSiteIdDetailsThemesDiscoverRoute
  '/n/sites/$siteId/logs': typeof NAuthSitesSiteIdDetailsLogsIndexRoute
  '/n/sites/$siteId/plugins': typeof NAuthSitesSiteIdDetailsPluginsIndexRoute
  '/n/sites/$siteId/reporting': typeof NAuthSitesSiteIdDetailsReportingIndexRoute
  '/n/sites/$siteId/themes': typeof NAuthSitesSiteIdDetailsThemesIndexRoute
  '/n/settings/billing/edit-plan/$planType': typeof NAuthSettingsLayoutBillingEditPlanTabsPlanTypeRoute
  '/n/settings/billing/edit-plan/order-confirmation/$orderId': typeof NAuthSettingsLayoutBillingEditPlanOrderConfirmationOrderIdRoute
  '/n/settings/billing/edit-plan': typeof NAuthSettingsLayoutBillingEditPlanTabsIndexRoute
  '/n/settings/billing/edit-plan/confirm/$planId/cycle/$billingCycle': typeof NAuthSettingsLayoutBillingEditPlanConfirmPlanIdCycleBillingCycleRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/account-error-message': typeof AccountErrorMessageRoute
  '/authentication-error-message': typeof AuthenticationErrorMessageRoute
  '/dashboard': typeof DashboardRoute
  '/dashboard-unavailable-message': typeof DashboardUnavailableMessageRoute
  '/error-message': typeof ErrorMessageRoute
  '/login': typeof LoginRouteWithChildren
  '/logout': typeof LogoutRoute
  '/post-login': typeof PostLoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sdk-missing-params-message': typeof SdkMissingParamsMessageRoute
  '/set-password': typeof SetPasswordRoute
  '/login/wpsitecontrol': typeof LoginWpsitecontrolRoute
  '/n/$': typeof NSplatRoute
  '/n/_auth': typeof NAuthRouteWithChildren
  '/n/_public': typeof NPublicRouteWithChildren
  '/n/account-error-message': typeof NAccountErrorMessageRoute
  '/n/account-switch-reauth': typeof NAccountSwitchReauthRoute
  '/n/authentication-error-message': typeof NAuthenticationErrorMessageRoute
  '/n/dashboard-unavailable-message': typeof NDashboardUnavailableMessageRoute
  '/n/error-message': typeof NErrorMessageRoute
  '/n/not-found': typeof NNotFoundRoute
  '/n/sdk-missing-params-message': typeof NSdkMissingParamsMessageRoute
  '/profile/change-password': typeof ProfileChangePasswordRoute
  '/sites/$': typeof SitesSplatRoute
  '/users/accept': typeof UsersAcceptRoute
  '/users/': typeof UsersIndexRoute
  '/manage/$siteId/phpmyadmin': typeof ManageSiteIdPhpmyadminRoute
  '/manage/$siteId/wordpress': typeof ManageSiteIdWordpressRoute
  '/n/_auth/dashboard': typeof NAuthDashboardRoute
  '/n/_auth/feature-requests': typeof NAuthFeatureRequestsRouteWithChildren
  '/n/_auth/no-accounts': typeof NAuthNoAccountsRoute
  '/n/_auth/settings': typeof NAuthSettingsRouteWithChildren
  '/n/_public/register': typeof NPublicRegisterRoute
  '/n/_auth/feature-requests/$': typeof NAuthFeatureRequestsSplatRoute
  '/n/_auth/register/plan': typeof NAuthRegisterPlanRoute
  '/n/_auth/register/success': typeof NAuthRegisterSuccessRoute
  '/n/_auth/settings/_layout': typeof NAuthSettingsLayoutRouteWithChildren
  '/n/_auth/sites/$siteId': typeof NAuthSitesSiteIdRouteWithChildren
  '/n/_auth/feature-requests/': typeof NAuthFeatureRequestsIndexRoute
  '/n/_auth/sites/': typeof NAuthSitesIndexRoute
  '/n/_auth/manage/$siteId/phpmyadmin': typeof NAuthManageSiteIdPhpmyadminRoute
  '/n/_auth/manage/$siteId/wordpress': typeof NAuthManageSiteIdWordpressRoute
  '/n/_auth/sites/$siteId/_details': typeof NAuthSitesSiteIdDetailsRouteWithChildren
  '/n/_auth/sites/$siteId/invite-accept': typeof NAuthSitesSiteIdInviteAcceptRoute
  '/n/_auth/settings/_layout/': typeof NAuthSettingsLayoutIndexRoute
  '/n/_auth/settings/_layout/account-and-security/change-password': typeof NAuthSettingsLayoutAccountAndSecurityChangePasswordRoute
  '/n/_auth/settings/_layout/billing/add-payment-method': typeof NAuthSettingsLayoutBillingAddPaymentMethodRoute
  '/n/_auth/settings/_layout/email-history/$emailId': typeof NAuthSettingsLayoutEmailHistoryEmailIdRoute
  '/n/_auth/settings/_layout/templates/$templateId': typeof NAuthSettingsLayoutTemplatesTemplateIdRoute
  '/n/_auth/sites/$siteId/_details/advanced': typeof NAuthSitesSiteIdDetailsAdvancedRoute
  '/n/_auth/sites/$siteId/_details/backups': typeof NAuthSitesSiteIdDetailsBackupsRoute
  '/n/_auth/sites/$siteId/_details/file-manager': typeof NAuthSitesSiteIdDetailsFileManagerRoute
  '/n/_auth/sites/$siteId/_details/logs': typeof NAuthSitesSiteIdDetailsLogsRouteWithChildren
  '/n/_auth/sites/$siteId/_details/overview': typeof NAuthSitesSiteIdDetailsOverviewRoute
  '/n/_auth/sites/$siteId/_details/plugins': typeof NAuthSitesSiteIdDetailsPluginsRouteWithChildren
  '/n/_auth/sites/$siteId/_details/reporting': typeof NAuthSitesSiteIdDetailsReportingRouteWithChildren
  '/n/_auth/sites/$siteId/_details/security': typeof NAuthSitesSiteIdDetailsSecurityRoute
  '/n/_auth/sites/$siteId/_details/themes': typeof NAuthSitesSiteIdDetailsThemesRouteWithChildren
  '/n/_auth/settings/_layout/account-and-security/': typeof NAuthSettingsLayoutAccountAndSecurityIndexRoute
  '/n/_auth/settings/_layout/billing/': typeof NAuthSettingsLayoutBillingIndexRoute
  '/n/_auth/settings/_layout/email-history/': typeof NAuthSettingsLayoutEmailHistoryIndexRoute
  '/n/_auth/settings/_layout/templates/': typeof NAuthSettingsLayoutTemplatesIndexRoute
  '/n/_auth/settings/_layout/users/': typeof NAuthSettingsLayoutUsersIndexRoute
  '/n/_auth/sites/$siteId/_details/': typeof NAuthSitesSiteIdDetailsIndexRoute
  '/n/_auth/settings/_layout/billing/edit-plan/_tabs': typeof NAuthSettingsLayoutBillingEditPlanTabsRouteWithChildren
  '/n/_auth/settings/_layout/billing/invoice/$invoiceId': typeof NAuthSettingsLayoutBillingInvoiceInvoiceIdRoute
  '/n/_auth/settings/_layout/users/$userId/account': typeof NAuthSettingsLayoutUsersUserIdAccountRoute
  '/n/_auth/settings/_layout/users/$userId/site': typeof NAuthSettingsLayoutUsersUserIdSiteRoute
  '/n/_auth/sites/$siteId/_details/logs/access-log': typeof NAuthSitesSiteIdDetailsLogsAccessLogRoute
  '/n/_auth/sites/$siteId/_details/logs/waf-log': typeof NAuthSitesSiteIdDetailsLogsWafLogRoute
  '/n/_auth/sites/$siteId/_details/plugins/discover': typeof NAuthSitesSiteIdDetailsPluginsDiscoverRoute
  '/n/_auth/sites/$siteId/_details/reporting/delivery': typeof NAuthSitesSiteIdDetailsReportingDeliveryRoute
  '/n/_auth/sites/$siteId/_details/reporting/waf': typeof NAuthSitesSiteIdDetailsReportingWafRoute
  '/n/_auth/sites/$siteId/_details/themes/discover': typeof NAuthSitesSiteIdDetailsThemesDiscoverRoute
  '/n/_auth/sites/$siteId/_details/logs/': typeof NAuthSitesSiteIdDetailsLogsIndexRoute
  '/n/_auth/sites/$siteId/_details/plugins/': typeof NAuthSitesSiteIdDetailsPluginsIndexRoute
  '/n/_auth/sites/$siteId/_details/reporting/': typeof NAuthSitesSiteIdDetailsReportingIndexRoute
  '/n/_auth/sites/$siteId/_details/themes/': typeof NAuthSitesSiteIdDetailsThemesIndexRoute
  '/n/_auth/settings/_layout/billing/edit-plan/_tabs/$planType': typeof NAuthSettingsLayoutBillingEditPlanTabsPlanTypeRoute
  '/n/_auth/settings/_layout/billing/edit-plan/order-confirmation/$orderId': typeof NAuthSettingsLayoutBillingEditPlanOrderConfirmationOrderIdRoute
  '/n/_auth/settings/_layout/billing/edit-plan/_tabs/': typeof NAuthSettingsLayoutBillingEditPlanTabsIndexRoute
  '/n/_auth/settings/_layout/billing/edit-plan/confirm/$planId/cycle/$billingCycle': typeof NAuthSettingsLayoutBillingEditPlanConfirmPlanIdCycleBillingCycleRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/account-error-message'
    | '/authentication-error-message'
    | '/dashboard'
    | '/dashboard-unavailable-message'
    | '/error-message'
    | '/login'
    | '/logout'
    | '/post-login'
    | '/reset-password'
    | '/sdk-missing-params-message'
    | '/set-password'
    | '/login/wpsitecontrol'
    | '/n/$'
    | '/n'
    | '/n/account-error-message'
    | '/n/account-switch-reauth'
    | '/n/authentication-error-message'
    | '/n/dashboard-unavailable-message'
    | '/n/error-message'
    | '/n/not-found'
    | '/n/sdk-missing-params-message'
    | '/profile/change-password'
    | '/sites/$'
    | '/users/accept'
    | '/users/'
    | '/manage/$siteId/phpmyadmin'
    | '/manage/$siteId/wordpress'
    | '/n/dashboard'
    | '/n/feature-requests'
    | '/n/no-accounts'
    | '/n/settings'
    | '/n/register'
    | '/n/feature-requests/$'
    | '/n/register/plan'
    | '/n/register/success'
    | '/n/sites/$siteId'
    | '/n/feature-requests/'
    | '/n/sites/'
    | '/n/manage/$siteId/phpmyadmin'
    | '/n/manage/$siteId/wordpress'
    | '/n/sites/$siteId/invite-accept'
    | '/n/settings/'
    | '/n/settings/account-and-security/change-password'
    | '/n/settings/billing/add-payment-method'
    | '/n/settings/email-history/$emailId'
    | '/n/settings/templates/$templateId'
    | '/n/sites/$siteId/advanced'
    | '/n/sites/$siteId/backups'
    | '/n/sites/$siteId/file-manager'
    | '/n/sites/$siteId/logs'
    | '/n/sites/$siteId/overview'
    | '/n/sites/$siteId/plugins'
    | '/n/sites/$siteId/reporting'
    | '/n/sites/$siteId/security'
    | '/n/sites/$siteId/themes'
    | '/n/settings/account-and-security/'
    | '/n/settings/billing/'
    | '/n/settings/email-history/'
    | '/n/settings/templates/'
    | '/n/settings/users/'
    | '/n/sites/$siteId/'
    | '/n/settings/billing/edit-plan'
    | '/n/settings/billing/invoice/$invoiceId'
    | '/n/settings/users/$userId/account'
    | '/n/settings/users/$userId/site'
    | '/n/sites/$siteId/logs/access-log'
    | '/n/sites/$siteId/logs/waf-log'
    | '/n/sites/$siteId/plugins/discover'
    | '/n/sites/$siteId/reporting/delivery'
    | '/n/sites/$siteId/reporting/waf'
    | '/n/sites/$siteId/themes/discover'
    | '/n/sites/$siteId/logs/'
    | '/n/sites/$siteId/plugins/'
    | '/n/sites/$siteId/reporting/'
    | '/n/sites/$siteId/themes/'
    | '/n/settings/billing/edit-plan/$planType'
    | '/n/settings/billing/edit-plan/order-confirmation/$orderId'
    | '/n/settings/billing/edit-plan/'
    | '/n/settings/billing/edit-plan/confirm/$planId/cycle/$billingCycle'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/account-error-message'
    | '/authentication-error-message'
    | '/dashboard'
    | '/dashboard-unavailable-message'
    | '/error-message'
    | '/login'
    | '/logout'
    | '/post-login'
    | '/reset-password'
    | '/sdk-missing-params-message'
    | '/set-password'
    | '/login/wpsitecontrol'
    | '/n/$'
    | '/n'
    | '/n/account-error-message'
    | '/n/account-switch-reauth'
    | '/n/authentication-error-message'
    | '/n/dashboard-unavailable-message'
    | '/n/error-message'
    | '/n/not-found'
    | '/n/sdk-missing-params-message'
    | '/profile/change-password'
    | '/sites/$'
    | '/users/accept'
    | '/users'
    | '/manage/$siteId/phpmyadmin'
    | '/manage/$siteId/wordpress'
    | '/n/dashboard'
    | '/n/no-accounts'
    | '/n/settings'
    | '/n/register'
    | '/n/feature-requests/$'
    | '/n/register/plan'
    | '/n/register/success'
    | '/n/sites/$siteId'
    | '/n/feature-requests'
    | '/n/sites'
    | '/n/manage/$siteId/phpmyadmin'
    | '/n/manage/$siteId/wordpress'
    | '/n/sites/$siteId/invite-accept'
    | '/n/settings/account-and-security/change-password'
    | '/n/settings/billing/add-payment-method'
    | '/n/settings/email-history/$emailId'
    | '/n/settings/templates/$templateId'
    | '/n/sites/$siteId/advanced'
    | '/n/sites/$siteId/backups'
    | '/n/sites/$siteId/file-manager'
    | '/n/sites/$siteId/overview'
    | '/n/sites/$siteId/security'
    | '/n/settings/account-and-security'
    | '/n/settings/billing'
    | '/n/settings/email-history'
    | '/n/settings/templates'
    | '/n/settings/users'
    | '/n/settings/billing/invoice/$invoiceId'
    | '/n/settings/users/$userId/account'
    | '/n/settings/users/$userId/site'
    | '/n/sites/$siteId/logs/access-log'
    | '/n/sites/$siteId/logs/waf-log'
    | '/n/sites/$siteId/plugins/discover'
    | '/n/sites/$siteId/reporting/delivery'
    | '/n/sites/$siteId/reporting/waf'
    | '/n/sites/$siteId/themes/discover'
    | '/n/sites/$siteId/logs'
    | '/n/sites/$siteId/plugins'
    | '/n/sites/$siteId/reporting'
    | '/n/sites/$siteId/themes'
    | '/n/settings/billing/edit-plan/$planType'
    | '/n/settings/billing/edit-plan/order-confirmation/$orderId'
    | '/n/settings/billing/edit-plan'
    | '/n/settings/billing/edit-plan/confirm/$planId/cycle/$billingCycle'
  id:
    | '__root__'
    | '/'
    | '/account-error-message'
    | '/authentication-error-message'
    | '/dashboard'
    | '/dashboard-unavailable-message'
    | '/error-message'
    | '/login'
    | '/logout'
    | '/post-login'
    | '/reset-password'
    | '/sdk-missing-params-message'
    | '/set-password'
    | '/login/wpsitecontrol'
    | '/n/$'
    | '/n/_auth'
    | '/n/_public'
    | '/n/account-error-message'
    | '/n/account-switch-reauth'
    | '/n/authentication-error-message'
    | '/n/dashboard-unavailable-message'
    | '/n/error-message'
    | '/n/not-found'
    | '/n/sdk-missing-params-message'
    | '/profile/change-password'
    | '/sites/$'
    | '/users/accept'
    | '/users/'
    | '/manage/$siteId/phpmyadmin'
    | '/manage/$siteId/wordpress'
    | '/n/_auth/dashboard'
    | '/n/_auth/feature-requests'
    | '/n/_auth/no-accounts'
    | '/n/_auth/settings'
    | '/n/_public/register'
    | '/n/_auth/feature-requests/$'
    | '/n/_auth/register/plan'
    | '/n/_auth/register/success'
    | '/n/_auth/settings/_layout'
    | '/n/_auth/sites/$siteId'
    | '/n/_auth/feature-requests/'
    | '/n/_auth/sites/'
    | '/n/_auth/manage/$siteId/phpmyadmin'
    | '/n/_auth/manage/$siteId/wordpress'
    | '/n/_auth/sites/$siteId/_details'
    | '/n/_auth/sites/$siteId/invite-accept'
    | '/n/_auth/settings/_layout/'
    | '/n/_auth/settings/_layout/account-and-security/change-password'
    | '/n/_auth/settings/_layout/billing/add-payment-method'
    | '/n/_auth/settings/_layout/email-history/$emailId'
    | '/n/_auth/settings/_layout/templates/$templateId'
    | '/n/_auth/sites/$siteId/_details/advanced'
    | '/n/_auth/sites/$siteId/_details/backups'
    | '/n/_auth/sites/$siteId/_details/file-manager'
    | '/n/_auth/sites/$siteId/_details/logs'
    | '/n/_auth/sites/$siteId/_details/overview'
    | '/n/_auth/sites/$siteId/_details/plugins'
    | '/n/_auth/sites/$siteId/_details/reporting'
    | '/n/_auth/sites/$siteId/_details/security'
    | '/n/_auth/sites/$siteId/_details/themes'
    | '/n/_auth/settings/_layout/account-and-security/'
    | '/n/_auth/settings/_layout/billing/'
    | '/n/_auth/settings/_layout/email-history/'
    | '/n/_auth/settings/_layout/templates/'
    | '/n/_auth/settings/_layout/users/'
    | '/n/_auth/sites/$siteId/_details/'
    | '/n/_auth/settings/_layout/billing/edit-plan/_tabs'
    | '/n/_auth/settings/_layout/billing/invoice/$invoiceId'
    | '/n/_auth/settings/_layout/users/$userId/account'
    | '/n/_auth/settings/_layout/users/$userId/site'
    | '/n/_auth/sites/$siteId/_details/logs/access-log'
    | '/n/_auth/sites/$siteId/_details/logs/waf-log'
    | '/n/_auth/sites/$siteId/_details/plugins/discover'
    | '/n/_auth/sites/$siteId/_details/reporting/delivery'
    | '/n/_auth/sites/$siteId/_details/reporting/waf'
    | '/n/_auth/sites/$siteId/_details/themes/discover'
    | '/n/_auth/sites/$siteId/_details/logs/'
    | '/n/_auth/sites/$siteId/_details/plugins/'
    | '/n/_auth/sites/$siteId/_details/reporting/'
    | '/n/_auth/sites/$siteId/_details/themes/'
    | '/n/_auth/settings/_layout/billing/edit-plan/_tabs/$planType'
    | '/n/_auth/settings/_layout/billing/edit-plan/order-confirmation/$orderId'
    | '/n/_auth/settings/_layout/billing/edit-plan/_tabs/'
    | '/n/_auth/settings/_layout/billing/edit-plan/confirm/$planId/cycle/$billingCycle'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccountErrorMessageRoute: typeof AccountErrorMessageRoute
  AuthenticationErrorMessageRoute: typeof AuthenticationErrorMessageRoute
  DashboardRoute: typeof DashboardRoute
  DashboardUnavailableMessageRoute: typeof DashboardUnavailableMessageRoute
  ErrorMessageRoute: typeof ErrorMessageRoute
  LoginRoute: typeof LoginRouteWithChildren
  LogoutRoute: typeof LogoutRoute
  PostLoginRoute: typeof PostLoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SdkMissingParamsMessageRoute: typeof SdkMissingParamsMessageRoute
  SetPasswordRoute: typeof SetPasswordRoute
  NSplatRoute: typeof NSplatRoute
  NAuthRoute: typeof NAuthRouteWithChildren
  NPublicRoute: typeof NPublicRouteWithChildren
  NAccountErrorMessageRoute: typeof NAccountErrorMessageRoute
  NAccountSwitchReauthRoute: typeof NAccountSwitchReauthRoute
  NAuthenticationErrorMessageRoute: typeof NAuthenticationErrorMessageRoute
  NDashboardUnavailableMessageRoute: typeof NDashboardUnavailableMessageRoute
  NErrorMessageRoute: typeof NErrorMessageRoute
  NNotFoundRoute: typeof NNotFoundRoute
  NSdkMissingParamsMessageRoute: typeof NSdkMissingParamsMessageRoute
  ProfileChangePasswordRoute: typeof ProfileChangePasswordRoute
  SitesSplatRoute: typeof SitesSplatRoute
  UsersAcceptRoute: typeof UsersAcceptRoute
  UsersIndexRoute: typeof UsersIndexRoute
  ManageSiteIdPhpmyadminRoute: typeof ManageSiteIdPhpmyadminRoute
  ManageSiteIdWordpressRoute: typeof ManageSiteIdWordpressRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/set-password': {
      id: '/set-password'
      path: '/set-password'
      fullPath: '/set-password'
      preLoaderRoute: typeof SetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sdk-missing-params-message': {
      id: '/sdk-missing-params-message'
      path: '/sdk-missing-params-message'
      fullPath: '/sdk-missing-params-message'
      preLoaderRoute: typeof SdkMissingParamsMessageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/post-login': {
      id: '/post-login'
      path: '/post-login'
      fullPath: '/post-login'
      preLoaderRoute: typeof PostLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/error-message': {
      id: '/error-message'
      path: '/error-message'
      fullPath: '/error-message'
      preLoaderRoute: typeof ErrorMessageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard-unavailable-message': {
      id: '/dashboard-unavailable-message'
      path: '/dashboard-unavailable-message'
      fullPath: '/dashboard-unavailable-message'
      preLoaderRoute: typeof DashboardUnavailableMessageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/authentication-error-message': {
      id: '/authentication-error-message'
      path: '/authentication-error-message'
      fullPath: '/authentication-error-message'
      preLoaderRoute: typeof AuthenticationErrorMessageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account-error-message': {
      id: '/account-error-message'
      path: '/account-error-message'
      fullPath: '/account-error-message'
      preLoaderRoute: typeof AccountErrorMessageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/': {
      id: '/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof UsersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/accept': {
      id: '/users/accept'
      path: '/users/accept'
      fullPath: '/users/accept'
      preLoaderRoute: typeof UsersAcceptRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sites/$': {
      id: '/sites/$'
      path: '/sites/$'
      fullPath: '/sites/$'
      preLoaderRoute: typeof SitesSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/change-password': {
      id: '/profile/change-password'
      path: '/profile/change-password'
      fullPath: '/profile/change-password'
      preLoaderRoute: typeof ProfileChangePasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/n/sdk-missing-params-message': {
      id: '/n/sdk-missing-params-message'
      path: '/n/sdk-missing-params-message'
      fullPath: '/n/sdk-missing-params-message'
      preLoaderRoute: typeof NSdkMissingParamsMessageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/n/not-found': {
      id: '/n/not-found'
      path: '/n/not-found'
      fullPath: '/n/not-found'
      preLoaderRoute: typeof NNotFoundRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/n/error-message': {
      id: '/n/error-message'
      path: '/n/error-message'
      fullPath: '/n/error-message'
      preLoaderRoute: typeof NErrorMessageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/n/dashboard-unavailable-message': {
      id: '/n/dashboard-unavailable-message'
      path: '/n/dashboard-unavailable-message'
      fullPath: '/n/dashboard-unavailable-message'
      preLoaderRoute: typeof NDashboardUnavailableMessageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/n/authentication-error-message': {
      id: '/n/authentication-error-message'
      path: '/n/authentication-error-message'
      fullPath: '/n/authentication-error-message'
      preLoaderRoute: typeof NAuthenticationErrorMessageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/n/account-switch-reauth': {
      id: '/n/account-switch-reauth'
      path: '/n/account-switch-reauth'
      fullPath: '/n/account-switch-reauth'
      preLoaderRoute: typeof NAccountSwitchReauthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/n/account-error-message': {
      id: '/n/account-error-message'
      path: '/n/account-error-message'
      fullPath: '/n/account-error-message'
      preLoaderRoute: typeof NAccountErrorMessageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/n/_public': {
      id: '/n/_public'
      path: '/n'
      fullPath: '/n'
      preLoaderRoute: typeof NPublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/n/_auth': {
      id: '/n/_auth'
      path: '/n'
      fullPath: '/n'
      preLoaderRoute: typeof NAuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/n/$': {
      id: '/n/$'
      path: '/n/$'
      fullPath: '/n/$'
      preLoaderRoute: typeof NSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/wpsitecontrol': {
      id: '/login/wpsitecontrol'
      path: '/wpsitecontrol'
      fullPath: '/login/wpsitecontrol'
      preLoaderRoute: typeof LoginWpsitecontrolRouteImport
      parentRoute: typeof LoginRoute
    }
    '/n/_public/register': {
      id: '/n/_public/register'
      path: '/register'
      fullPath: '/n/register'
      preLoaderRoute: typeof NPublicRegisterRouteImport
      parentRoute: typeof NPublicRoute
    }
    '/n/_auth/settings': {
      id: '/n/_auth/settings'
      path: '/settings'
      fullPath: '/n/settings'
      preLoaderRoute: typeof NAuthSettingsRouteImport
      parentRoute: typeof NAuthRoute
    }
    '/n/_auth/no-accounts': {
      id: '/n/_auth/no-accounts'
      path: '/no-accounts'
      fullPath: '/n/no-accounts'
      preLoaderRoute: typeof NAuthNoAccountsRouteImport
      parentRoute: typeof NAuthRoute
    }
    '/n/_auth/feature-requests': {
      id: '/n/_auth/feature-requests'
      path: '/feature-requests'
      fullPath: '/n/feature-requests'
      preLoaderRoute: typeof NAuthFeatureRequestsRouteImport
      parentRoute: typeof NAuthRoute
    }
    '/n/_auth/dashboard': {
      id: '/n/_auth/dashboard'
      path: '/dashboard'
      fullPath: '/n/dashboard'
      preLoaderRoute: typeof NAuthDashboardRouteImport
      parentRoute: typeof NAuthRoute
    }
    '/manage/$siteId/wordpress': {
      id: '/manage/$siteId/wordpress'
      path: '/manage/$siteId/wordpress'
      fullPath: '/manage/$siteId/wordpress'
      preLoaderRoute: typeof ManageSiteIdWordpressRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/manage/$siteId/phpmyadmin': {
      id: '/manage/$siteId/phpmyadmin'
      path: '/manage/$siteId/phpmyadmin'
      fullPath: '/manage/$siteId/phpmyadmin'
      preLoaderRoute: typeof ManageSiteIdPhpmyadminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/n/_auth/sites/': {
      id: '/n/_auth/sites/'
      path: '/sites'
      fullPath: '/n/sites/'
      preLoaderRoute: typeof NAuthSitesIndexRouteImport
      parentRoute: typeof NAuthRoute
    }
    '/n/_auth/feature-requests/': {
      id: '/n/_auth/feature-requests/'
      path: '/'
      fullPath: '/n/feature-requests/'
      preLoaderRoute: typeof NAuthFeatureRequestsIndexRouteImport
      parentRoute: typeof NAuthFeatureRequestsRoute
    }
    '/n/_auth/sites/$siteId': {
      id: '/n/_auth/sites/$siteId'
      path: '/sites/$siteId'
      fullPath: '/n/sites/$siteId'
      preLoaderRoute: typeof NAuthSitesSiteIdRouteImport
      parentRoute: typeof NAuthRoute
    }
    '/n/_auth/settings/_layout': {
      id: '/n/_auth/settings/_layout'
      path: ''
      fullPath: '/n/settings'
      preLoaderRoute: typeof NAuthSettingsLayoutRouteImport
      parentRoute: typeof NAuthSettingsRoute
    }
    '/n/_auth/register/success': {
      id: '/n/_auth/register/success'
      path: '/register/success'
      fullPath: '/n/register/success'
      preLoaderRoute: typeof NAuthRegisterSuccessRouteImport
      parentRoute: typeof NAuthRoute
    }
    '/n/_auth/register/plan': {
      id: '/n/_auth/register/plan'
      path: '/register/plan'
      fullPath: '/n/register/plan'
      preLoaderRoute: typeof NAuthRegisterPlanRouteImport
      parentRoute: typeof NAuthRoute
    }
    '/n/_auth/feature-requests/$': {
      id: '/n/_auth/feature-requests/$'
      path: '/$'
      fullPath: '/n/feature-requests/$'
      preLoaderRoute: typeof NAuthFeatureRequestsSplatRouteImport
      parentRoute: typeof NAuthFeatureRequestsRoute
    }
    '/n/_auth/settings/_layout/': {
      id: '/n/_auth/settings/_layout/'
      path: '/'
      fullPath: '/n/settings/'
      preLoaderRoute: typeof NAuthSettingsLayoutIndexRouteImport
      parentRoute: typeof NAuthSettingsLayoutRoute
    }
    '/n/_auth/sites/$siteId/invite-accept': {
      id: '/n/_auth/sites/$siteId/invite-accept'
      path: '/invite-accept'
      fullPath: '/n/sites/$siteId/invite-accept'
      preLoaderRoute: typeof NAuthSitesSiteIdInviteAcceptRouteImport
      parentRoute: typeof NAuthSitesSiteIdRoute
    }
    '/n/_auth/sites/$siteId/_details': {
      id: '/n/_auth/sites/$siteId/_details'
      path: ''
      fullPath: '/n/sites/$siteId'
      preLoaderRoute: typeof NAuthSitesSiteIdDetailsRouteImport
      parentRoute: typeof NAuthSitesSiteIdRoute
    }
    '/n/_auth/manage/$siteId/wordpress': {
      id: '/n/_auth/manage/$siteId/wordpress'
      path: '/manage/$siteId/wordpress'
      fullPath: '/n/manage/$siteId/wordpress'
      preLoaderRoute: typeof NAuthManageSiteIdWordpressRouteImport
      parentRoute: typeof NAuthRoute
    }
    '/n/_auth/manage/$siteId/phpmyadmin': {
      id: '/n/_auth/manage/$siteId/phpmyadmin'
      path: '/manage/$siteId/phpmyadmin'
      fullPath: '/n/manage/$siteId/phpmyadmin'
      preLoaderRoute: typeof NAuthManageSiteIdPhpmyadminRouteImport
      parentRoute: typeof NAuthRoute
    }
    '/n/_auth/sites/$siteId/_details/': {
      id: '/n/_auth/sites/$siteId/_details/'
      path: '/'
      fullPath: '/n/sites/$siteId/'
      preLoaderRoute: typeof NAuthSitesSiteIdDetailsIndexRouteImport
      parentRoute: typeof NAuthSitesSiteIdDetailsRoute
    }
    '/n/_auth/settings/_layout/users/': {
      id: '/n/_auth/settings/_layout/users/'
      path: '/users'
      fullPath: '/n/settings/users/'
      preLoaderRoute: typeof NAuthSettingsLayoutUsersIndexRouteImport
      parentRoute: typeof NAuthSettingsLayoutRoute
    }
    '/n/_auth/settings/_layout/templates/': {
      id: '/n/_auth/settings/_layout/templates/'
      path: '/templates'
      fullPath: '/n/settings/templates/'
      preLoaderRoute: typeof NAuthSettingsLayoutTemplatesIndexRouteImport
      parentRoute: typeof NAuthSettingsLayoutRoute
    }
    '/n/_auth/settings/_layout/email-history/': {
      id: '/n/_auth/settings/_layout/email-history/'
      path: '/email-history'
      fullPath: '/n/settings/email-history/'
      preLoaderRoute: typeof NAuthSettingsLayoutEmailHistoryIndexRouteImport
      parentRoute: typeof NAuthSettingsLayoutRoute
    }
    '/n/_auth/settings/_layout/billing/': {
      id: '/n/_auth/settings/_layout/billing/'
      path: '/billing'
      fullPath: '/n/settings/billing/'
      preLoaderRoute: typeof NAuthSettingsLayoutBillingIndexRouteImport
      parentRoute: typeof NAuthSettingsLayoutRoute
    }
    '/n/_auth/settings/_layout/account-and-security/': {
      id: '/n/_auth/settings/_layout/account-and-security/'
      path: '/account-and-security'
      fullPath: '/n/settings/account-and-security/'
      preLoaderRoute: typeof NAuthSettingsLayoutAccountAndSecurityIndexRouteImport
      parentRoute: typeof NAuthSettingsLayoutRoute
    }
    '/n/_auth/sites/$siteId/_details/themes': {
      id: '/n/_auth/sites/$siteId/_details/themes'
      path: '/themes'
      fullPath: '/n/sites/$siteId/themes'
      preLoaderRoute: typeof NAuthSitesSiteIdDetailsThemesRouteImport
      parentRoute: typeof NAuthSitesSiteIdDetailsRoute
    }
    '/n/_auth/sites/$siteId/_details/security': {
      id: '/n/_auth/sites/$siteId/_details/security'
      path: '/security'
      fullPath: '/n/sites/$siteId/security'
      preLoaderRoute: typeof NAuthSitesSiteIdDetailsSecurityRouteImport
      parentRoute: typeof NAuthSitesSiteIdDetailsRoute
    }
    '/n/_auth/sites/$siteId/_details/reporting': {
      id: '/n/_auth/sites/$siteId/_details/reporting'
      path: '/reporting'
      fullPath: '/n/sites/$siteId/reporting'
      preLoaderRoute: typeof NAuthSitesSiteIdDetailsReportingRouteImport
      parentRoute: typeof NAuthSitesSiteIdDetailsRoute
    }
    '/n/_auth/sites/$siteId/_details/plugins': {
      id: '/n/_auth/sites/$siteId/_details/plugins'
      path: '/plugins'
      fullPath: '/n/sites/$siteId/plugins'
      preLoaderRoute: typeof NAuthSitesSiteIdDetailsPluginsRouteImport
      parentRoute: typeof NAuthSitesSiteIdDetailsRoute
    }
    '/n/_auth/sites/$siteId/_details/overview': {
      id: '/n/_auth/sites/$siteId/_details/overview'
      path: '/overview'
      fullPath: '/n/sites/$siteId/overview'
      preLoaderRoute: typeof NAuthSitesSiteIdDetailsOverviewRouteImport
      parentRoute: typeof NAuthSitesSiteIdDetailsRoute
    }
    '/n/_auth/sites/$siteId/_details/logs': {
      id: '/n/_auth/sites/$siteId/_details/logs'
      path: '/logs'
      fullPath: '/n/sites/$siteId/logs'
      preLoaderRoute: typeof NAuthSitesSiteIdDetailsLogsRouteImport
      parentRoute: typeof NAuthSitesSiteIdDetailsRoute
    }
    '/n/_auth/sites/$siteId/_details/file-manager': {
      id: '/n/_auth/sites/$siteId/_details/file-manager'
      path: '/file-manager'
      fullPath: '/n/sites/$siteId/file-manager'
      preLoaderRoute: typeof NAuthSitesSiteIdDetailsFileManagerRouteImport
      parentRoute: typeof NAuthSitesSiteIdDetailsRoute
    }
    '/n/_auth/sites/$siteId/_details/backups': {
      id: '/n/_auth/sites/$siteId/_details/backups'
      path: '/backups'
      fullPath: '/n/sites/$siteId/backups'
      preLoaderRoute: typeof NAuthSitesSiteIdDetailsBackupsRouteImport
      parentRoute: typeof NAuthSitesSiteIdDetailsRoute
    }
    '/n/_auth/sites/$siteId/_details/advanced': {
      id: '/n/_auth/sites/$siteId/_details/advanced'
      path: '/advanced'
      fullPath: '/n/sites/$siteId/advanced'
      preLoaderRoute: typeof NAuthSitesSiteIdDetailsAdvancedRouteImport
      parentRoute: typeof NAuthSitesSiteIdDetailsRoute
    }
    '/n/_auth/settings/_layout/templates/$templateId': {
      id: '/n/_auth/settings/_layout/templates/$templateId'
      path: '/templates/$templateId'
      fullPath: '/n/settings/templates/$templateId'
      preLoaderRoute: typeof NAuthSettingsLayoutTemplatesTemplateIdRouteImport
      parentRoute: typeof NAuthSettingsLayoutRoute
    }
    '/n/_auth/settings/_layout/email-history/$emailId': {
      id: '/n/_auth/settings/_layout/email-history/$emailId'
      path: '/email-history/$emailId'
      fullPath: '/n/settings/email-history/$emailId'
      preLoaderRoute: typeof NAuthSettingsLayoutEmailHistoryEmailIdRouteImport
      parentRoute: typeof NAuthSettingsLayoutRoute
    }
    '/n/_auth/settings/_layout/billing/add-payment-method': {
      id: '/n/_auth/settings/_layout/billing/add-payment-method'
      path: '/billing/add-payment-method'
      fullPath: '/n/settings/billing/add-payment-method'
      preLoaderRoute: typeof NAuthSettingsLayoutBillingAddPaymentMethodRouteImport
      parentRoute: typeof NAuthSettingsLayoutRoute
    }
    '/n/_auth/settings/_layout/account-and-security/change-password': {
      id: '/n/_auth/settings/_layout/account-and-security/change-password'
      path: '/account-and-security/change-password'
      fullPath: '/n/settings/account-and-security/change-password'
      preLoaderRoute: typeof NAuthSettingsLayoutAccountAndSecurityChangePasswordRouteImport
      parentRoute: typeof NAuthSettingsLayoutRoute
    }
    '/n/_auth/sites/$siteId/_details/themes/': {
      id: '/n/_auth/sites/$siteId/_details/themes/'
      path: '/'
      fullPath: '/n/sites/$siteId/themes/'
      preLoaderRoute: typeof NAuthSitesSiteIdDetailsThemesIndexRouteImport
      parentRoute: typeof NAuthSitesSiteIdDetailsThemesRoute
    }
    '/n/_auth/sites/$siteId/_details/reporting/': {
      id: '/n/_auth/sites/$siteId/_details/reporting/'
      path: '/'
      fullPath: '/n/sites/$siteId/reporting/'
      preLoaderRoute: typeof NAuthSitesSiteIdDetailsReportingIndexRouteImport
      parentRoute: typeof NAuthSitesSiteIdDetailsReportingRoute
    }
    '/n/_auth/sites/$siteId/_details/plugins/': {
      id: '/n/_auth/sites/$siteId/_details/plugins/'
      path: '/'
      fullPath: '/n/sites/$siteId/plugins/'
      preLoaderRoute: typeof NAuthSitesSiteIdDetailsPluginsIndexRouteImport
      parentRoute: typeof NAuthSitesSiteIdDetailsPluginsRoute
    }
    '/n/_auth/sites/$siteId/_details/logs/': {
      id: '/n/_auth/sites/$siteId/_details/logs/'
      path: '/'
      fullPath: '/n/sites/$siteId/logs/'
      preLoaderRoute: typeof NAuthSitesSiteIdDetailsLogsIndexRouteImport
      parentRoute: typeof NAuthSitesSiteIdDetailsLogsRoute
    }
    '/n/_auth/sites/$siteId/_details/themes/discover': {
      id: '/n/_auth/sites/$siteId/_details/themes/discover'
      path: '/discover'
      fullPath: '/n/sites/$siteId/themes/discover'
      preLoaderRoute: typeof NAuthSitesSiteIdDetailsThemesDiscoverRouteImport
      parentRoute: typeof NAuthSitesSiteIdDetailsThemesRoute
    }
    '/n/_auth/sites/$siteId/_details/reporting/waf': {
      id: '/n/_auth/sites/$siteId/_details/reporting/waf'
      path: '/waf'
      fullPath: '/n/sites/$siteId/reporting/waf'
      preLoaderRoute: typeof NAuthSitesSiteIdDetailsReportingWafRouteImport
      parentRoute: typeof NAuthSitesSiteIdDetailsReportingRoute
    }
    '/n/_auth/sites/$siteId/_details/reporting/delivery': {
      id: '/n/_auth/sites/$siteId/_details/reporting/delivery'
      path: '/delivery'
      fullPath: '/n/sites/$siteId/reporting/delivery'
      preLoaderRoute: typeof NAuthSitesSiteIdDetailsReportingDeliveryRouteImport
      parentRoute: typeof NAuthSitesSiteIdDetailsReportingRoute
    }
    '/n/_auth/sites/$siteId/_details/plugins/discover': {
      id: '/n/_auth/sites/$siteId/_details/plugins/discover'
      path: '/discover'
      fullPath: '/n/sites/$siteId/plugins/discover'
      preLoaderRoute: typeof NAuthSitesSiteIdDetailsPluginsDiscoverRouteImport
      parentRoute: typeof NAuthSitesSiteIdDetailsPluginsRoute
    }
    '/n/_auth/sites/$siteId/_details/logs/waf-log': {
      id: '/n/_auth/sites/$siteId/_details/logs/waf-log'
      path: '/waf-log'
      fullPath: '/n/sites/$siteId/logs/waf-log'
      preLoaderRoute: typeof NAuthSitesSiteIdDetailsLogsWafLogRouteImport
      parentRoute: typeof NAuthSitesSiteIdDetailsLogsRoute
    }
    '/n/_auth/sites/$siteId/_details/logs/access-log': {
      id: '/n/_auth/sites/$siteId/_details/logs/access-log'
      path: '/access-log'
      fullPath: '/n/sites/$siteId/logs/access-log'
      preLoaderRoute: typeof NAuthSitesSiteIdDetailsLogsAccessLogRouteImport
      parentRoute: typeof NAuthSitesSiteIdDetailsLogsRoute
    }
    '/n/_auth/settings/_layout/users/$userId/site': {
      id: '/n/_auth/settings/_layout/users/$userId/site'
      path: '/users/$userId/site'
      fullPath: '/n/settings/users/$userId/site'
      preLoaderRoute: typeof NAuthSettingsLayoutUsersUserIdSiteRouteImport
      parentRoute: typeof NAuthSettingsLayoutRoute
    }
    '/n/_auth/settings/_layout/users/$userId/account': {
      id: '/n/_auth/settings/_layout/users/$userId/account'
      path: '/users/$userId/account'
      fullPath: '/n/settings/users/$userId/account'
      preLoaderRoute: typeof NAuthSettingsLayoutUsersUserIdAccountRouteImport
      parentRoute: typeof NAuthSettingsLayoutRoute
    }
    '/n/_auth/settings/_layout/billing/invoice/$invoiceId': {
      id: '/n/_auth/settings/_layout/billing/invoice/$invoiceId'
      path: '/billing/invoice/$invoiceId'
      fullPath: '/n/settings/billing/invoice/$invoiceId'
      preLoaderRoute: typeof NAuthSettingsLayoutBillingInvoiceInvoiceIdRouteImport
      parentRoute: typeof NAuthSettingsLayoutRoute
    }
    '/n/_auth/settings/_layout/billing/edit-plan/_tabs': {
      id: '/n/_auth/settings/_layout/billing/edit-plan/_tabs'
      path: '/billing/edit-plan'
      fullPath: '/n/settings/billing/edit-plan'
      preLoaderRoute: typeof NAuthSettingsLayoutBillingEditPlanTabsRouteImport
      parentRoute: typeof NAuthSettingsLayoutRoute
    }
    '/n/_auth/settings/_layout/billing/edit-plan/_tabs/': {
      id: '/n/_auth/settings/_layout/billing/edit-plan/_tabs/'
      path: '/'
      fullPath: '/n/settings/billing/edit-plan/'
      preLoaderRoute: typeof NAuthSettingsLayoutBillingEditPlanTabsIndexRouteImport
      parentRoute: typeof NAuthSettingsLayoutBillingEditPlanTabsRoute
    }
    '/n/_auth/settings/_layout/billing/edit-plan/order-confirmation/$orderId': {
      id: '/n/_auth/settings/_layout/billing/edit-plan/order-confirmation/$orderId'
      path: '/billing/edit-plan/order-confirmation/$orderId'
      fullPath: '/n/settings/billing/edit-plan/order-confirmation/$orderId'
      preLoaderRoute: typeof NAuthSettingsLayoutBillingEditPlanOrderConfirmationOrderIdRouteImport
      parentRoute: typeof NAuthSettingsLayoutRoute
    }
    '/n/_auth/settings/_layout/billing/edit-plan/_tabs/$planType': {
      id: '/n/_auth/settings/_layout/billing/edit-plan/_tabs/$planType'
      path: '/$planType'
      fullPath: '/n/settings/billing/edit-plan/$planType'
      preLoaderRoute: typeof NAuthSettingsLayoutBillingEditPlanTabsPlanTypeRouteImport
      parentRoute: typeof NAuthSettingsLayoutBillingEditPlanTabsRoute
    }
    '/n/_auth/settings/_layout/billing/edit-plan/confirm/$planId/cycle/$billingCycle': {
      id: '/n/_auth/settings/_layout/billing/edit-plan/confirm/$planId/cycle/$billingCycle'
      path: '/billing/edit-plan/confirm/$planId/cycle/$billingCycle'
      fullPath: '/n/settings/billing/edit-plan/confirm/$planId/cycle/$billingCycle'
      preLoaderRoute: typeof NAuthSettingsLayoutBillingEditPlanConfirmPlanIdCycleBillingCycleRouteImport
      parentRoute: typeof NAuthSettingsLayoutRoute
    }
  }
}

interface LoginRouteChildren {
  LoginWpsitecontrolRoute: typeof LoginWpsitecontrolRoute
}

const LoginRouteChildren: LoginRouteChildren = {
  LoginWpsitecontrolRoute: LoginWpsitecontrolRoute,
}

const LoginRouteWithChildren = LoginRoute._addFileChildren(LoginRouteChildren)

interface NAuthFeatureRequestsRouteChildren {
  NAuthFeatureRequestsSplatRoute: typeof NAuthFeatureRequestsSplatRoute
  NAuthFeatureRequestsIndexRoute: typeof NAuthFeatureRequestsIndexRoute
}

const NAuthFeatureRequestsRouteChildren: NAuthFeatureRequestsRouteChildren = {
  NAuthFeatureRequestsSplatRoute: NAuthFeatureRequestsSplatRoute,
  NAuthFeatureRequestsIndexRoute: NAuthFeatureRequestsIndexRoute,
}

const NAuthFeatureRequestsRouteWithChildren =
  NAuthFeatureRequestsRoute._addFileChildren(NAuthFeatureRequestsRouteChildren)

interface NAuthSettingsLayoutBillingEditPlanTabsRouteChildren {
  NAuthSettingsLayoutBillingEditPlanTabsPlanTypeRoute: typeof NAuthSettingsLayoutBillingEditPlanTabsPlanTypeRoute
  NAuthSettingsLayoutBillingEditPlanTabsIndexRoute: typeof NAuthSettingsLayoutBillingEditPlanTabsIndexRoute
}

const NAuthSettingsLayoutBillingEditPlanTabsRouteChildren: NAuthSettingsLayoutBillingEditPlanTabsRouteChildren =
  {
    NAuthSettingsLayoutBillingEditPlanTabsPlanTypeRoute:
      NAuthSettingsLayoutBillingEditPlanTabsPlanTypeRoute,
    NAuthSettingsLayoutBillingEditPlanTabsIndexRoute:
      NAuthSettingsLayoutBillingEditPlanTabsIndexRoute,
  }

const NAuthSettingsLayoutBillingEditPlanTabsRouteWithChildren =
  NAuthSettingsLayoutBillingEditPlanTabsRoute._addFileChildren(
    NAuthSettingsLayoutBillingEditPlanTabsRouteChildren,
  )

interface NAuthSettingsLayoutRouteChildren {
  NAuthSettingsLayoutIndexRoute: typeof NAuthSettingsLayoutIndexRoute
  NAuthSettingsLayoutAccountAndSecurityChangePasswordRoute: typeof NAuthSettingsLayoutAccountAndSecurityChangePasswordRoute
  NAuthSettingsLayoutBillingAddPaymentMethodRoute: typeof NAuthSettingsLayoutBillingAddPaymentMethodRoute
  NAuthSettingsLayoutEmailHistoryEmailIdRoute: typeof NAuthSettingsLayoutEmailHistoryEmailIdRoute
  NAuthSettingsLayoutTemplatesTemplateIdRoute: typeof NAuthSettingsLayoutTemplatesTemplateIdRoute
  NAuthSettingsLayoutAccountAndSecurityIndexRoute: typeof NAuthSettingsLayoutAccountAndSecurityIndexRoute
  NAuthSettingsLayoutBillingIndexRoute: typeof NAuthSettingsLayoutBillingIndexRoute
  NAuthSettingsLayoutEmailHistoryIndexRoute: typeof NAuthSettingsLayoutEmailHistoryIndexRoute
  NAuthSettingsLayoutTemplatesIndexRoute: typeof NAuthSettingsLayoutTemplatesIndexRoute
  NAuthSettingsLayoutUsersIndexRoute: typeof NAuthSettingsLayoutUsersIndexRoute
  NAuthSettingsLayoutBillingEditPlanTabsRoute: typeof NAuthSettingsLayoutBillingEditPlanTabsRouteWithChildren
  NAuthSettingsLayoutBillingInvoiceInvoiceIdRoute: typeof NAuthSettingsLayoutBillingInvoiceInvoiceIdRoute
  NAuthSettingsLayoutUsersUserIdAccountRoute: typeof NAuthSettingsLayoutUsersUserIdAccountRoute
  NAuthSettingsLayoutUsersUserIdSiteRoute: typeof NAuthSettingsLayoutUsersUserIdSiteRoute
  NAuthSettingsLayoutBillingEditPlanOrderConfirmationOrderIdRoute: typeof NAuthSettingsLayoutBillingEditPlanOrderConfirmationOrderIdRoute
  NAuthSettingsLayoutBillingEditPlanConfirmPlanIdCycleBillingCycleRoute: typeof NAuthSettingsLayoutBillingEditPlanConfirmPlanIdCycleBillingCycleRoute
}

const NAuthSettingsLayoutRouteChildren: NAuthSettingsLayoutRouteChildren = {
  NAuthSettingsLayoutIndexRoute: NAuthSettingsLayoutIndexRoute,
  NAuthSettingsLayoutAccountAndSecurityChangePasswordRoute:
    NAuthSettingsLayoutAccountAndSecurityChangePasswordRoute,
  NAuthSettingsLayoutBillingAddPaymentMethodRoute:
    NAuthSettingsLayoutBillingAddPaymentMethodRoute,
  NAuthSettingsLayoutEmailHistoryEmailIdRoute:
    NAuthSettingsLayoutEmailHistoryEmailIdRoute,
  NAuthSettingsLayoutTemplatesTemplateIdRoute:
    NAuthSettingsLayoutTemplatesTemplateIdRoute,
  NAuthSettingsLayoutAccountAndSecurityIndexRoute:
    NAuthSettingsLayoutAccountAndSecurityIndexRoute,
  NAuthSettingsLayoutBillingIndexRoute: NAuthSettingsLayoutBillingIndexRoute,
  NAuthSettingsLayoutEmailHistoryIndexRoute:
    NAuthSettingsLayoutEmailHistoryIndexRoute,
  NAuthSettingsLayoutTemplatesIndexRoute:
    NAuthSettingsLayoutTemplatesIndexRoute,
  NAuthSettingsLayoutUsersIndexRoute: NAuthSettingsLayoutUsersIndexRoute,
  NAuthSettingsLayoutBillingEditPlanTabsRoute:
    NAuthSettingsLayoutBillingEditPlanTabsRouteWithChildren,
  NAuthSettingsLayoutBillingInvoiceInvoiceIdRoute:
    NAuthSettingsLayoutBillingInvoiceInvoiceIdRoute,
  NAuthSettingsLayoutUsersUserIdAccountRoute:
    NAuthSettingsLayoutUsersUserIdAccountRoute,
  NAuthSettingsLayoutUsersUserIdSiteRoute:
    NAuthSettingsLayoutUsersUserIdSiteRoute,
  NAuthSettingsLayoutBillingEditPlanOrderConfirmationOrderIdRoute:
    NAuthSettingsLayoutBillingEditPlanOrderConfirmationOrderIdRoute,
  NAuthSettingsLayoutBillingEditPlanConfirmPlanIdCycleBillingCycleRoute:
    NAuthSettingsLayoutBillingEditPlanConfirmPlanIdCycleBillingCycleRoute,
}

const NAuthSettingsLayoutRouteWithChildren =
  NAuthSettingsLayoutRoute._addFileChildren(NAuthSettingsLayoutRouteChildren)

interface NAuthSettingsRouteChildren {
  NAuthSettingsLayoutRoute: typeof NAuthSettingsLayoutRouteWithChildren
}

const NAuthSettingsRouteChildren: NAuthSettingsRouteChildren = {
  NAuthSettingsLayoutRoute: NAuthSettingsLayoutRouteWithChildren,
}

const NAuthSettingsRouteWithChildren = NAuthSettingsRoute._addFileChildren(
  NAuthSettingsRouteChildren,
)

interface NAuthSitesSiteIdDetailsLogsRouteChildren {
  NAuthSitesSiteIdDetailsLogsAccessLogRoute: typeof NAuthSitesSiteIdDetailsLogsAccessLogRoute
  NAuthSitesSiteIdDetailsLogsWafLogRoute: typeof NAuthSitesSiteIdDetailsLogsWafLogRoute
  NAuthSitesSiteIdDetailsLogsIndexRoute: typeof NAuthSitesSiteIdDetailsLogsIndexRoute
}

const NAuthSitesSiteIdDetailsLogsRouteChildren: NAuthSitesSiteIdDetailsLogsRouteChildren =
  {
    NAuthSitesSiteIdDetailsLogsAccessLogRoute:
      NAuthSitesSiteIdDetailsLogsAccessLogRoute,
    NAuthSitesSiteIdDetailsLogsWafLogRoute:
      NAuthSitesSiteIdDetailsLogsWafLogRoute,
    NAuthSitesSiteIdDetailsLogsIndexRoute:
      NAuthSitesSiteIdDetailsLogsIndexRoute,
  }

const NAuthSitesSiteIdDetailsLogsRouteWithChildren =
  NAuthSitesSiteIdDetailsLogsRoute._addFileChildren(
    NAuthSitesSiteIdDetailsLogsRouteChildren,
  )

interface NAuthSitesSiteIdDetailsPluginsRouteChildren {
  NAuthSitesSiteIdDetailsPluginsDiscoverRoute: typeof NAuthSitesSiteIdDetailsPluginsDiscoverRoute
  NAuthSitesSiteIdDetailsPluginsIndexRoute: typeof NAuthSitesSiteIdDetailsPluginsIndexRoute
}

const NAuthSitesSiteIdDetailsPluginsRouteChildren: NAuthSitesSiteIdDetailsPluginsRouteChildren =
  {
    NAuthSitesSiteIdDetailsPluginsDiscoverRoute:
      NAuthSitesSiteIdDetailsPluginsDiscoverRoute,
    NAuthSitesSiteIdDetailsPluginsIndexRoute:
      NAuthSitesSiteIdDetailsPluginsIndexRoute,
  }

const NAuthSitesSiteIdDetailsPluginsRouteWithChildren =
  NAuthSitesSiteIdDetailsPluginsRoute._addFileChildren(
    NAuthSitesSiteIdDetailsPluginsRouteChildren,
  )

interface NAuthSitesSiteIdDetailsReportingRouteChildren {
  NAuthSitesSiteIdDetailsReportingDeliveryRoute: typeof NAuthSitesSiteIdDetailsReportingDeliveryRoute
  NAuthSitesSiteIdDetailsReportingWafRoute: typeof NAuthSitesSiteIdDetailsReportingWafRoute
  NAuthSitesSiteIdDetailsReportingIndexRoute: typeof NAuthSitesSiteIdDetailsReportingIndexRoute
}

const NAuthSitesSiteIdDetailsReportingRouteChildren: NAuthSitesSiteIdDetailsReportingRouteChildren =
  {
    NAuthSitesSiteIdDetailsReportingDeliveryRoute:
      NAuthSitesSiteIdDetailsReportingDeliveryRoute,
    NAuthSitesSiteIdDetailsReportingWafRoute:
      NAuthSitesSiteIdDetailsReportingWafRoute,
    NAuthSitesSiteIdDetailsReportingIndexRoute:
      NAuthSitesSiteIdDetailsReportingIndexRoute,
  }

const NAuthSitesSiteIdDetailsReportingRouteWithChildren =
  NAuthSitesSiteIdDetailsReportingRoute._addFileChildren(
    NAuthSitesSiteIdDetailsReportingRouteChildren,
  )

interface NAuthSitesSiteIdDetailsThemesRouteChildren {
  NAuthSitesSiteIdDetailsThemesDiscoverRoute: typeof NAuthSitesSiteIdDetailsThemesDiscoverRoute
  NAuthSitesSiteIdDetailsThemesIndexRoute: typeof NAuthSitesSiteIdDetailsThemesIndexRoute
}

const NAuthSitesSiteIdDetailsThemesRouteChildren: NAuthSitesSiteIdDetailsThemesRouteChildren =
  {
    NAuthSitesSiteIdDetailsThemesDiscoverRoute:
      NAuthSitesSiteIdDetailsThemesDiscoverRoute,
    NAuthSitesSiteIdDetailsThemesIndexRoute:
      NAuthSitesSiteIdDetailsThemesIndexRoute,
  }

const NAuthSitesSiteIdDetailsThemesRouteWithChildren =
  NAuthSitesSiteIdDetailsThemesRoute._addFileChildren(
    NAuthSitesSiteIdDetailsThemesRouteChildren,
  )

interface NAuthSitesSiteIdDetailsRouteChildren {
  NAuthSitesSiteIdDetailsAdvancedRoute: typeof NAuthSitesSiteIdDetailsAdvancedRoute
  NAuthSitesSiteIdDetailsBackupsRoute: typeof NAuthSitesSiteIdDetailsBackupsRoute
  NAuthSitesSiteIdDetailsFileManagerRoute: typeof NAuthSitesSiteIdDetailsFileManagerRoute
  NAuthSitesSiteIdDetailsLogsRoute: typeof NAuthSitesSiteIdDetailsLogsRouteWithChildren
  NAuthSitesSiteIdDetailsOverviewRoute: typeof NAuthSitesSiteIdDetailsOverviewRoute
  NAuthSitesSiteIdDetailsPluginsRoute: typeof NAuthSitesSiteIdDetailsPluginsRouteWithChildren
  NAuthSitesSiteIdDetailsReportingRoute: typeof NAuthSitesSiteIdDetailsReportingRouteWithChildren
  NAuthSitesSiteIdDetailsSecurityRoute: typeof NAuthSitesSiteIdDetailsSecurityRoute
  NAuthSitesSiteIdDetailsThemesRoute: typeof NAuthSitesSiteIdDetailsThemesRouteWithChildren
  NAuthSitesSiteIdDetailsIndexRoute: typeof NAuthSitesSiteIdDetailsIndexRoute
}

const NAuthSitesSiteIdDetailsRouteChildren: NAuthSitesSiteIdDetailsRouteChildren =
  {
    NAuthSitesSiteIdDetailsAdvancedRoute: NAuthSitesSiteIdDetailsAdvancedRoute,
    NAuthSitesSiteIdDetailsBackupsRoute: NAuthSitesSiteIdDetailsBackupsRoute,
    NAuthSitesSiteIdDetailsFileManagerRoute:
      NAuthSitesSiteIdDetailsFileManagerRoute,
    NAuthSitesSiteIdDetailsLogsRoute:
      NAuthSitesSiteIdDetailsLogsRouteWithChildren,
    NAuthSitesSiteIdDetailsOverviewRoute: NAuthSitesSiteIdDetailsOverviewRoute,
    NAuthSitesSiteIdDetailsPluginsRoute:
      NAuthSitesSiteIdDetailsPluginsRouteWithChildren,
    NAuthSitesSiteIdDetailsReportingRoute:
      NAuthSitesSiteIdDetailsReportingRouteWithChildren,
    NAuthSitesSiteIdDetailsSecurityRoute: NAuthSitesSiteIdDetailsSecurityRoute,
    NAuthSitesSiteIdDetailsThemesRoute:
      NAuthSitesSiteIdDetailsThemesRouteWithChildren,
    NAuthSitesSiteIdDetailsIndexRoute: NAuthSitesSiteIdDetailsIndexRoute,
  }

const NAuthSitesSiteIdDetailsRouteWithChildren =
  NAuthSitesSiteIdDetailsRoute._addFileChildren(
    NAuthSitesSiteIdDetailsRouteChildren,
  )

interface NAuthSitesSiteIdRouteChildren {
  NAuthSitesSiteIdDetailsRoute: typeof NAuthSitesSiteIdDetailsRouteWithChildren
  NAuthSitesSiteIdInviteAcceptRoute: typeof NAuthSitesSiteIdInviteAcceptRoute
}

const NAuthSitesSiteIdRouteChildren: NAuthSitesSiteIdRouteChildren = {
  NAuthSitesSiteIdDetailsRoute: NAuthSitesSiteIdDetailsRouteWithChildren,
  NAuthSitesSiteIdInviteAcceptRoute: NAuthSitesSiteIdInviteAcceptRoute,
}

const NAuthSitesSiteIdRouteWithChildren =
  NAuthSitesSiteIdRoute._addFileChildren(NAuthSitesSiteIdRouteChildren)

interface NAuthRouteChildren {
  NAuthDashboardRoute: typeof NAuthDashboardRoute
  NAuthFeatureRequestsRoute: typeof NAuthFeatureRequestsRouteWithChildren
  NAuthNoAccountsRoute: typeof NAuthNoAccountsRoute
  NAuthSettingsRoute: typeof NAuthSettingsRouteWithChildren
  NAuthRegisterPlanRoute: typeof NAuthRegisterPlanRoute
  NAuthRegisterSuccessRoute: typeof NAuthRegisterSuccessRoute
  NAuthSitesSiteIdRoute: typeof NAuthSitesSiteIdRouteWithChildren
  NAuthSitesIndexRoute: typeof NAuthSitesIndexRoute
  NAuthManageSiteIdPhpmyadminRoute: typeof NAuthManageSiteIdPhpmyadminRoute
  NAuthManageSiteIdWordpressRoute: typeof NAuthManageSiteIdWordpressRoute
}

const NAuthRouteChildren: NAuthRouteChildren = {
  NAuthDashboardRoute: NAuthDashboardRoute,
  NAuthFeatureRequestsRoute: NAuthFeatureRequestsRouteWithChildren,
  NAuthNoAccountsRoute: NAuthNoAccountsRoute,
  NAuthSettingsRoute: NAuthSettingsRouteWithChildren,
  NAuthRegisterPlanRoute: NAuthRegisterPlanRoute,
  NAuthRegisterSuccessRoute: NAuthRegisterSuccessRoute,
  NAuthSitesSiteIdRoute: NAuthSitesSiteIdRouteWithChildren,
  NAuthSitesIndexRoute: NAuthSitesIndexRoute,
  NAuthManageSiteIdPhpmyadminRoute: NAuthManageSiteIdPhpmyadminRoute,
  NAuthManageSiteIdWordpressRoute: NAuthManageSiteIdWordpressRoute,
}

const NAuthRouteWithChildren = NAuthRoute._addFileChildren(NAuthRouteChildren)

interface NPublicRouteChildren {
  NPublicRegisterRoute: typeof NPublicRegisterRoute
}

const NPublicRouteChildren: NPublicRouteChildren = {
  NPublicRegisterRoute: NPublicRegisterRoute,
}

const NPublicRouteWithChildren =
  NPublicRoute._addFileChildren(NPublicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccountErrorMessageRoute: AccountErrorMessageRoute,
  AuthenticationErrorMessageRoute: AuthenticationErrorMessageRoute,
  DashboardRoute: DashboardRoute,
  DashboardUnavailableMessageRoute: DashboardUnavailableMessageRoute,
  ErrorMessageRoute: ErrorMessageRoute,
  LoginRoute: LoginRouteWithChildren,
  LogoutRoute: LogoutRoute,
  PostLoginRoute: PostLoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SdkMissingParamsMessageRoute: SdkMissingParamsMessageRoute,
  SetPasswordRoute: SetPasswordRoute,
  NSplatRoute: NSplatRoute,
  NAuthRoute: NAuthRouteWithChildren,
  NPublicRoute: NPublicRouteWithChildren,
  NAccountErrorMessageRoute: NAccountErrorMessageRoute,
  NAccountSwitchReauthRoute: NAccountSwitchReauthRoute,
  NAuthenticationErrorMessageRoute: NAuthenticationErrorMessageRoute,
  NDashboardUnavailableMessageRoute: NDashboardUnavailableMessageRoute,
  NErrorMessageRoute: NErrorMessageRoute,
  NNotFoundRoute: NNotFoundRoute,
  NSdkMissingParamsMessageRoute: NSdkMissingParamsMessageRoute,
  ProfileChangePasswordRoute: ProfileChangePasswordRoute,
  SitesSplatRoute: SitesSplatRoute,
  UsersAcceptRoute: UsersAcceptRoute,
  UsersIndexRoute: UsersIndexRoute,
  ManageSiteIdPhpmyadminRoute: ManageSiteIdPhpmyadminRoute,
  ManageSiteIdWordpressRoute: ManageSiteIdWordpressRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
